<template>
  <v-container fluid  pa-0 ma-0 class="new-order">
    <v-tabs
      fixed-tabs
      dark
      height="35"
      dense
      v-model="selectedPromotionTab"
      class="fill-height promotion-tabs"
      background-color="#136DF5"
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab href="#promotionPDFGenerator">Nopea PDF tarjous </v-tab>
      <!-- <v-tab href="#promotionPDFGeneratorOld">Nopea PDF tarjous</v-tab> -->
      <v-tab href="#promotionCreator">Sähköpostitarjous</v-tab>
      <v-tab href="#promotionResults" >Sähköpostitarjouksen tulokset</v-tab>
      <v-tab href="#promotionLists">Sähköpostitarjouslistat</v-tab>
      <v-tab-item value="promotionPDFGenerator" >
        <v-row no-gutters fill-height>
          <v-col cols="12" sm="5" style="height:91.3vh;overflow-y:scroll;overflow-x:hidden;">
            <v-container>
              <v-row no-gutters class="my-6 mx-3">
                <v-col sm="6" class="pr-3 text-left">
                  <v-btn @click="resetPromotion()" class="avecor-button-global mr-6" >Tyhjennä</v-btn>
                </v-col>
                <v-col sm="6" class="text-right">    
                  <v-btn @click="clickedSave = true; generatePreview()" class="avecor-button-global">
                    <span class="hidden-sm-and-down">Lataa Tarjous</span>
                    <v-icon size=14 right>fas fa-download</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row no-gutters class="mx-3 my-6">
                <v-col sm="8" class="pr-3 text-left">
                  <v-text-field
                    class="hide-field-details"  
                    label="Uuden tarjouspohjan nimi"
                    placeholder=" "
                    :value="newPromotionTemplateName"
                    @change="v => newPromotionTemplateName = v" />
                </v-col>
                <v-col sm="4" class="text-right">
                  <v-btn color="#000000" @click="createPromotionTemplate()" tile dark class="add-button avecor-button-global">Tallenna uudeksi tarjouspohjaksi</v-btn>  
                </v-col>
              </v-row>
              <v-row no-gutters class="mx-3 mt-3 mb-3">
                <v-col sm="4" class="pr-3" >
                  <v-autocomplete
                    v-model="selectedPromotionTemplateId"
                    :items="getPromotionTemplates"
                    label="Valitse tallennettu tarjouspohja (ei pakollinen)"
                    hint=""
                    autocomplete="off"
                    placeholder=" "
                    item-text="text"
                    item-value="value"
                    @change="promotionTemplateFieldChanged"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        small
                        solo
                        class="chip--select-multi"
                        @click:close="removePromotionTemplateSelection()"
                      >
                        {{ data.item.text.substr(0,500) }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="4" class="pr-3">
                  <v-text-field
                    label="Tarjouspohjan nimi"
                    placeholder=" "
                    :disabled="selectedPromotionTemplateId === ''" 
                    :value="promotionTemplateName"
                    @change="v => promotionTemplateName = v" />
                </v-col>
                <v-col sm="4" class="text-right">
                  <v-row no-gutters>
                    <v-col cols="5" class="text-right">
                      <v-btn v-if="this.selectedPromotionTemplateId !== ''" color="#000000" @click="deletePromotionTemplate(selectedPromotionTemplateId); removePromotionTemplateSelection()" class="add-button avecor-button-global mt-2 mr-2">Poista</v-btn>
                    </v-col>
                    <v-col cols="7">
                      <v-btn v-if="this.selectedPromotionTemplateId !== ''" color="#000000" @click="updatePromotionTemplate()" class="add-button avecor-button-global mt-2">Tallenna muutokset</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row no-gutters class="mr-3 ml-3 mt-3">
                <v-col sm="5" class="pr-3">
                  <v-text-field
                    label="Sähköpostin otsikko (näkyy sähköpostiohjelmassa)"
                    placeholder=" "
                    :value="promotionEmailSubject" 
                    @change="v => promotionEmailSubject = v"/>
                </v-col>
                <v-col sm="5" class="pr-3">
                  <v-text-field
                    label="Viestin otsikko"
                    placeholder=" "
                    :value="promotionMainHeadline" 
                    @change="v => promotionMainHeadline = v"/>
                </v-col>
                <v-col sm="2">
                  <v-menu
                    :nudge-right="40"
                    transition="fade-transition"
                    offset-y
                    min-width="30px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        label="Tarjous voimassa"     
                        v-model="promotionValidDate"
                        readonly
                      ></v-text-field>
                    </template>
                    
                    <v-date-picker v-model="promotionValidDate"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row no-gutters class="mr-3 ml-3 mt-3">
                <v-col sm="12">
                  <v-textarea
                    label="Viestin pääteksti (otsikon alla)"
                    placeholder=" "
                    :auto-grow="autogrow"
                    rows=1
                    :value="promotionMainSubHeader" 
                    @change="v => promotionMainSubHeader = v"/>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-container>
            
            <div class="ma-2">  
              <NewPromotionProducts ref="newPromotionProducts" location="pdfPromotion"></NewPromotionProducts>
            </div>
          </v-col>
          <v-col cols="12" sm="7" class="pt-0" style="border-left:1px dotted #ccc;" >
            <v-row no-gutters style="height:100%" >
              <v-col class="text-center px-0" cols="12" style="width:100%;height:91.3vh">
                <iframe style="width:100%;height:100%" id="pdfPreview" ref="pdfPreview" type="application/pdf"></iframe>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item value="promotionPDFGeneratorOld" class="fill-height">
        <v-row no-gutters fill-height>
          <v-col cols="12" sm="6" >
            <v-container>
              <v-row no-gutters class="my-6 mx-3">
                <v-col sm="6" class="pr-3 text-left">
                  <v-btn @click="resetPromotion()" class="avecor-button-global mr-6" >Tyhjennä</v-btn>
                </v-col>
                <v-col sm="6" class="text-right">    
                  <v-btn @click="downloadAsPDF()" class="avecor-button-global">
                    <span class="hidden-sm-and-down">Lataa Tarjous</span>
                    <v-icon size=14 right>fas fa-download</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row no-gutters class="mx-3 my-6">
                <v-col sm="8" class="pr-3 text-left">
                  <v-text-field
                    class="hide-field-details"  
                    label="Uuden tarjouspohjan nimi"
                    placeholder=" "
                    :value="newPromotionTemplateName"
                    @change="v => newPromotionTemplateName = v" />
                </v-col>
                <v-col sm="4" class="text-right">
                  <v-btn color="#000000" @click="createPromotionTemplate()" tile dark class="add-button avecor-button-global">Tallenna uudeksi tarjouspohjaksi</v-btn>  
                </v-col>
              </v-row>
              <v-row no-gutters class="mx-3 mt-3 mb-3">
                <v-col sm="4" class="pr-3" >
                  <v-autocomplete
                    v-model="selectedPromotionTemplateId"
                    :items="getPromotionTemplates"
                    label="Valitse tallennettu tarjouspohja (ei pakollinen)"
                    hint=""
                    autocomplete="off"
                    placeholder=" "
                    item-text="text"
                    item-value="value"
                    @change="promotionTemplateFieldChanged"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        small
                        solo
                        class="chip--select-multi"
                        @click:close="removePromotionTemplateSelection()"
                      >
                        {{ data.item.text.substr(0,500) }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="4" class="pr-3">
                  <v-text-field
                    label="Tarjouspohjan nimi"
                    placeholder=" "
                    :disabled="selectedPromotionTemplateId === ''" 
                    :value="promotionTemplateName"
                    @change="v => promotionTemplateName = v" />
                </v-col>
                <v-col sm="4" class="text-right">
                  <v-row no-gutters>
                    <v-col cols="5" class="text-right">
                      <v-btn v-if="this.selectedPromotionTemplateId !== ''" color="#000000" @click="deletePromotionTemplate(selectedPromotionTemplateId); removePromotionTemplateSelection()" class="add-button avecor-button-global mt-2">Poista</v-btn>
                    </v-col>
                    <v-col cols="7">
                      <v-btn v-if="this.selectedPromotionTemplateId !== ''" color="#000000" @click="updatePromotionTemplate()" class="add-button avecor-button-global mt-2">Tallenna muutokset</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row no-gutters class="mr-3 ml-3 mt-3">
                <v-col sm="5" class="pr-3">
                  <v-text-field
                    label="Sähköpostin otsikko (näkyy sähköpostiohjelmassa)"
                    placeholder=" "
                    :value="promotionEmailSubject" 
                    @change="v => promotionEmailSubject = v"/>
                </v-col>
                <v-col sm="5" class="pr-3">
                  <v-text-field
                    label="Viestin otsikko"
                    placeholder=" "
                    :value="promotionMainHeadline" 
                    @change="v => promotionMainHeadline = v"/>
                </v-col>
                <v-col sm="2">
                  <v-menu
                    :nudge-right="40"
                    transition="fade-transition"
                    offset-y
                    min-width="30px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        label="Tarjous voimassa"     
                        v-model="promotionValidDate"
                        readonly
                      ></v-text-field>
                    </template>
                    
                    <v-date-picker v-model="promotionValidDate"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row no-gutters class="mr-3 ml-3 mt-3">
                <v-col sm="12">
                  <v-textarea
                    label="Viestin pääteksti (otsikon alla)"
                    placeholder=" "
                    :auto-grow="autogrow"
                    rows=1
                    :value="promotionMainSubHeader" 
                    @change="v => promotionMainSubHeader = v"/>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-container>
            
            <div class="ma-2">  
              <NewPromotionProducts ref="newPromotionProducts"></NewPromotionProducts>
            </div>
          </v-col>
          <v-col cols="12" sm="6" class="pt-3" style="border-left:1px dotted #ccc;" >
            <!-- <v-row no-gutters>
              <v-col xs12 class="text-center">
                <v-btn-toggle
                  v-model="previewDevice"
                  tile 
                >
                  <v-btn value="mobile" class="avecor-button-global" height="40" >
                    <span class="hidden-sm-and-down">Mobiili</span>
                    <v-icon size=14 right>fas fa-mobile-alt</v-icon>
                  </v-btn>
                  <v-btn value="desktop" class="avecor-button-global" height="40" >
                    <span class="hidden-sm-and-down">Pöytäkone</span>
                    <v-icon size=14 right>fas fa-desktop</v-icon>
                  </v-btn>
                  <v-btn value="pdf" class="avecor-button-global" height="40" >
                    <span class="hidden-sm-and-down">PDF</span>
                    <v-icon size=14 right>fas fa-file-pdf</v-icon>
                  </v-btn>
                </v-btn-toggle>
                <v-btn @click="downloadAsPDF()" class="avecor-button-global ml-4">
                  <span class="hidden-sm-and-down">Lataa Tarjous</span>
                  <v-icon size=14 right>fas fa-download</v-icon>
                </v-btn>
              </v-col>
            </v-row> -->
            <v-row no-gutters style="padding-top:30px;" >
              <v-col class="text-center ma-5">
                <div id="promotionPDFPreview" :style="'max-width:1000px; width:100%'" ref="promotionPDFPreview">
                  {{ content }}
                </div>
                <div style="display:none">
                  <div id="promotionPDFPreviewForCanvas" style="'margin:0 auto;'" ref="promotionPDFPreviewForCanvas" />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item value="promotionLists" class="fill-height">
         <v-row no-gutters class="fill-height">
            <v-col cols="2" style="border-right:1px solid #eee">
              <v-row no-gutters style="color:#888; background:#FFF; line-height:40px" class="pl-3 pr-5">
                Kontaktilistat
                <v-spacer></v-spacer>
                <button style="outline:none" @mouseup.stop="addList()">
                  <v-icon :size=12 color='#888'>fas fa-plus</v-icon>
                </button>
              </v-row>
              <v-list dense class="pa-0 ma-0">
                <v-list-item-group v-model="selectedList" color="primary" >
                  <v-list-item
                    v-for="(item) in Object.keys(getLists).reduce((result,key) => {result.push({text:staff[lists[key].created_by].firstName+' - '+lists[key].name,value:lists[key].id}); return result},[])"
                    :key="item.value"
                    :value="item.value"
                  >
                    <v-list-item-content>
                      <v-row no-gutters>
                        <v-col cols="10" >
                          <v-list-item-title v-text="item.text"></v-list-item-title>
                        </v-col>
                        <v-spacer />
                        <v-col cols="2" class="text-right pr-5">
                          <v-icon @mouseup.stop="deleteList(selectedList)" v-if="selectedList === item.value" :size=12 color='#000'>fas fa-trash</v-icon>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
            <v-col cols="6" v-if="selectedList !== ''" class="pl-5 pt-5 pr-5" style="border-right:1px solid #eee">
              
              <v-row no-gutters class="mt-2">
                <v-col cols="5" class="pr-5">
                  <v-text-field
                    label="Listan nimi (kuvaava teksti listan kontakteista)"
                    :value="lists[selectedList] !== undefined ? lists[selectedList].name : ''"
                    dense
                    @change="(name) => updateListName(name)"
                    class="manage-text-field"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-6">
                <div>Lisää olemassa oleva kontakti</div>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="pr-5">
                  <v-autocomplete
                    v-model="selectedCompanyIdForList"
                    :items="getCompanies"
                    label="Etsi yrityksiä"
                    placeholder=" "
                    item-text="text"
                    autocomplete="off"
                    :error-messages="addExistingContacterrors.company"
                    @blur="(event) => {event === '' ? addExistingContacterrors.company = 'Täytä kenttä' : addExistingContacterrors.company = '';}"
                    item-value="value"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        small
                        solo
                        class="chip--select-multi"
                        @click:close="removeCompanySelectionForList()"
                      >
                        {{ data.item.text.substr(0,20) }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="5" class="pr-5">
                  <v-autocomplete
                    :disabled="selectedCompanyIdForList === ''"
                    v-model="selectedContactIdForList"
                    :items="getContactsForList"
                    label="Valitse kontakti"
                    placeholder=" "
                    item-text="text"
                    item-value="value"
                    autocomplete="off"
                    :error-messages="addExistingContacterrors.contact"
                    @blur="(event) => {event === '' ? addExistingContacterrors.contact = 'Täytä kenttä' : addExistingContacterrors.contact = '';}"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        small
                        close
                        class="chip--select-multi"
                        @click:close="removeContactSelectionForList()"
                      >
                        {{ data.item.text.substr(0,20) }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="2" class="pt-4 text-right">
                  <v-btn @click="addContactToList()"  class="add-button avecor-button-global mr-3" >Lisää listaan</v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-6">
                <v-col cols="12">
                  <div style="width:100%;">Lisää uusi yritys ja kontakti</div>
                </v-col>
                <v-col cols="12" class="pb-6 pt-2">
                  <div style="font-size:10px; color:#888;">Tarkista onko yritys ja kontakti jo olemassa ensiksi. Jos ei, syötä tähän yrityksen ja kontaktin tiedot. Jatkossa nämä ovat käytettävissä läpi järjestelmän.</div>
                </v-col>
                <v-col cols="3" class="pr-3">
                  <v-text-field
                    label="Yrityksen nimi*"
                    placeholder=" "
                    :error-messages="listErrors.companyName"
                    @blur="(event) => {event.target.value === '' ? listErrors.companyName = 'Täytä kenttä' : listErrors.companyName = ''; list.companyName = event.target.value}"
                    :value="list.companyName" 
                    @change="v => list.companyName = v"/>
                </v-col>
                <v-col cols="2" class="pr-3">
                  <v-text-field
                    label="Y-tunnus"
                    placeholder=" "
                    @blur="(event) => {list.companyId = event.target.value}"
                    :value="list.companyId" />
                </v-col>
                <v-col cols="4" class="pr-3">
                  <v-text-field
                    label="Toimitusosoite*"
                    placeholder=" "
                    :error-messages="listErrors.deliveryAddress"
                    @blur="(event) => {event.target.value === '' ? listErrors.deliveryAddress = 'Täytä kenttä' : listErrors.deliveryAddress = ''; list.deliveryAddress = event.target.value}"
                    :value="list.deliveryAddress" />
                </v-col>
                <v-col cols="1" class="pr-3">
                  <v-text-field
                    label="Postikoodi*"
                    placeholder=" "
                    :error-messages="listErrors.deliveryPostalCode"
                    @blur="(event) => {event.target.value === '' ? listErrors.deliveryPostalCode = 'Täytä kenttä' : listErrors.deliveryPostalCode = ''; list.deliveryPostalCode = event.target.value}"
                    :value="list.deliveryPostalCode" />
                </v-col>
                <v-col cols="1" class="pr-3">
                  <v-text-field
                    label="Toimipaikka*"
                    placeholder=" " 
                    :error-messages="listErrors.deliveryCity"
                    @blur="(event) => {event.target.value === '' ? listErrors.deliveryCity = 'Täytä kenttä' : listErrors.deliveryCity = ''; list.deliveryCity = event.target.value}"
                    :value="list.deliveryCity" />
                </v-col>
                <v-col cols="1">
                  <v-text-field
                    label="Maa*"
                    placeholder=" " 
                    :error-messages="listErrors.deliveryCountry"
                    @blur="(event) => {event.target.value === '' ? listErrors.deliveryCountry = 'Täytä kenttä' : listErrors.deliveryCountry = ''; list.deliveryCountry = event.target.value}"
                    :value="list.deliveryCountry" />
                </v-col>
                <v-col sm="3" class="pr-3">
                  <v-text-field
                    label="Etunimi*"
                    placeholder=" "
                    :error-messages="listErrors.firstName"
                    @blur="(event) => {event.target.value === '' ? listErrors.firstName = 'Täytä kenttä' : listErrors.firstName = ''; list.firstName = event.target.value}"
                    :value="list.firstName"
                  ></v-text-field>
                </v-col>
                <v-col sm="3" class="pr-3">
                  <v-text-field
                    label="Sukunimi*"
                    placeholder=" "
                    :error-messages="listErrors.lastName"
                    @blur="(event) => {event.target.value === '' ? listErrors.lastName = 'Täytä kenttä' : listErrors.lastName = ''; list.lastName = event.target.value}"
                    :value="list.lastName"
                  ></v-text-field>
                </v-col>
                <v-col sm="3" class="pr-3">
                  <v-text-field
                    label="Tilaajan puhelinnumero*"
                    placeholder=" "
                    :error-messages="listErrors.clientPhone"
                    @blur="(event) => {event.target.value === '' ? listErrors.clientPhone = 'Täytä kenttä' : listErrors.clientPhone = ''; list.clientPhone = event.target.value}"
                    :value="list.clientPhone"
                  ></v-text-field>
                </v-col>
                <v-col sm="3" >
                  <v-text-field
                    label="Tilaajan sähköpostiosoite*"
                    placeholder=" "
                    :error-messages="listErrors.clientEmail"
                    @blur="(event) => {!emailTestPattern.test(event.target.value) ? listErrors.clientEmail = 'Täytä validi sähköposti' : listErrors.clientEmail = ''; list.clientEmail = event.target.value}"
                    :value="list.clientEmail"
                  ></v-text-field>
                </v-col>
                
                <v-col cols="2" class="pt-4 text-left">
                  <v-btn @click="createAndAddContactToList()"  class="add-button avecor-button-global mr-3" >Lisää listaan</v-btn>
                </v-col>
                <v-col cols="2" class="pt-4 text-left">
                  <v-btn @click="emptyAddContactToList()"  class="add-button avecor-button-global mr-3" >Tyhjennä</v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" v-if="selectedList !== ''" class="pt-5">
              <v-row no-gutters style="color:#888; background:#FFF; line-height:40px" class="pl-3 pr-5">
                Kontaktit listalla
                <v-spacer></v-spacer>
                <!-- <v-icon :size=12 color='#888'>fas fa-plus</v-icon> -->
              </v-row>
              <v-list dense class=" ma-0">
                <v-list-item-group >
                  <v-list-item
                    v-for="(item,index) in lists[selectedList].contacts"
                    :key="'list-contacts-contact-'+index"
                    :value="item.value"
                  >
                    
                    <v-list-item-content >
                      <!-- <div>{{lists[selectedList].contacts}}</div> -->
                      <v-row no-gutters v-if="contacts[item.contactId] !== undefined">
                        <v-col cols="1">
                          <v-icon @mouseup.stop="removeContactFromList({contactId:item.contactId,companyId:item.companyId})" :size=14 color='#888'>fas fa-trash</v-icon>
                        </v-col>
                        <v-col cols="11">
                          <v-list-item-title v-text="companies[item.companyId].companyName + ' - ' +contacts[item.contactId].firstName + ' ' + contacts[item.contactId].lastName + '  (' + contacts[item.contactId].email + ')'"></v-list-item-title>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
         </v-row>
      </v-tab-item>
      <v-tab-item value="promotionResults" class="avecor-table">
        <div style="width:100%;height:91.3vh;overflow-y:scroll;">
          <v-row no-gutters style="border:1px dotted #ccc;" class="pt-5 pb-5">
            <v-col cols="1" class="orders-custom-header pr-1"></v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Avecor Id</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Lähetys päivämäärä</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Tarjouksen tekijä</v-col>
            <v-col cols="2" class="orders-custom-header pr-1">Tarjouksen sähköpostin otsikko</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Tarjous voimassa</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Yritys</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Kontakti/lista</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Lähetykset</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Avaukset</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Klikit</v-col>
          </v-row>
          <v-row no-gutters v-for="(promotion, index) in promotions" style="border:1px dotted #ccc; " class="avecor-order-row" :key="promotion.id">
            <v-col cols="1" >
              <div class="justify-center text-center minw-75 maxw-75" >
                <v-icon :size="10" @click="selectedPromotionIdForResults = promotion.id" style="padding-right:5px;">far fa-eye</v-icon>
                <v-icon :size="10" @click="deletePromotion(promotion.id)" style="padding-right:1px;">far fa-trash-alt</v-icon>
              </div>
            </v-col>
            <v-col cols="1">
              <div class="orders-custom-field" @click="copyToClipboard(promotion.id)" style="color:rgba(0,0,0,.38);">{{promotion.id}}</div>
            </v-col>
            <v-col cols="1">
              <v-text-field
                slot="activator"
                class="avecor-date-picker hide-field-details"  
                :value="promotion.created_at ? customFormatter(promotion.created_at) : ''"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <div class="orders-custom-field" @click="copyToClipboard(staff[promotion.created_by].firstName)" style="color:rgba(0,0,0,.38);">{{staff[promotion.created_by].firstName}}</div>
            </v-col>
            <v-col cols="2">
              <div class="orders-custom-field" @click="copyToClipboard(promotion.promotionEmailSubject)" style="color:rgba(0,0,0,.38);">{{promotion.promotionEmailSubject}}</div>
            </v-col>
            <v-col cols="1">
              <v-text-field
                slot="activator"
                class="avecor-date-picker hide-field-details"  
                :value="promotion.promotionValidDate ? promotion.promotionValidDate : ''"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <div class="orders-custom-field" @click="copyToClipboard(companies[promotion.companyId].companyName)" style="color:rgba(0,0,0,.38);">{{companies[promotion.companyId].companyName}}</div>
            </v-col>
            <v-col cols="1">
              <div class="orders-custom-field" @click="copyToClipboard(contacts[promotion.contactId].firstName + ' ' +contacts[promotion.contactId].lastName)" style="color:rgba(0,0,0,.38);">{{contacts[promotion.contactId].firstName + " " + contacts[promotion.contactId].lastName}}</div>
            </v-col>
            <v-col cols="1">
              <div class="orders-custom-field" @click="copyToClipboard(promotion.emailSends)" style="color:rgba(0,0,0,.38);">{{promotion.emailSends}}</div>
            </v-col>
            <v-col cols="1">
              <div class="orders-custom-field" @click="copyToClipboard(promotion.emailOpens)" style="color:rgba(0,0,0,.38);">{{promotion.emailOpens}}</div>
            </v-col>
            <v-col cols="1">
              <div class="orders-custom-field" @click="copyToClipboard(promotion.emailClicks)" style="color:rgba(0,0,0,.38);">{{promotion.emailClicks}}</div>
            </v-col>
          </v-row>
        </div>
        <v-row no-gutters style="position:fixed; bottom:0px; z-index:100; background:#eee; border:1px solid #ccc; width:100%;">
          <PromotionResultsTable v-if="selectedPromotionIdForResults !== ''" @removeSelectedPromotionIdForResults="() => selectedPromotionIdForResults= ''" :promotionId="selectedPromotionIdForResults" ></PromotionResultsTable>
        </v-row>
      </v-tab-item>
      <v-tab-item value="promotionCreator" eager>
        <v-row no-gutters fill-height>
          <v-col cols="12" sm="6" style="height:91.3vh;overflow-y:scroll;overflow-x:hidden;">
            <div class="pt-4 pb-4 xs6 pl-3" style="background:#ddd; font-size:12px;" v-if="showInstructions">
              Tarjouksen voi luoda kolmella tavalla. 1) Valitsemalla aikasemmin lähetetyn tarjousken ja muokkaamalla tarjousta uudelle tai samalle asiakkaalle. 2) Valitsemalla tarjouspohjan, lisäämällä yrityksen ja kontaktin ja muokkaamalla tarjouksen tietoja. 3) Tyhjästä.
              <h4 class="mt-3 mb-3">Valitsemalla aikaisemman tarjouksen</h4>
              <ol style="font-size:11px">
                <li>
                    Klikkaa valitse aikaisemmin lähetetty tarjous kentän päältä.
                </li>
                <li>
                    Esille tulee näkyviin tarjoukset, jotka olet lähettänyt ennen. Admin-käyttäjille tulee kaikki tarjoukset näkyviin. Valitse yksi näistä
                </li>
                <li>
                    Järjestelmä näyttää vanhan tarjouksen tiedot pohjana, jota voit lähteä vapaasti muokkaamaan. Uudet tiedot ei tallennu automaattisesti. Tiedot tallennetaan lähettämällä tarjous ja/tai tallentamalla tarjouspohja. Tarjouspohjaan ei tallenneta yritys/kontakti tietoja ja ovat näkyvissä kaikille. 
                </li>
                <li>
                    Kun olet lisännyt tiedot, niin paina lähetä testi. Tämä lähettää Avecor-sähköpostiisi tarjouksen, jonka voit vilkaista. Tämä vaihe ei ole pakollinen.
                </li>
                <li>
                    Paina "Lähetä tarjous". Tarjous lähetetään tilaajan sähköpostiin, joka on näkyvillä kun valitset kontaktin. Tarjouksesta lähtee myös kopio sinulle.
                </li>
              </ol>
              <h4 class="mt-3 mb-3">Valitsemalla tarjouspohjan</h4>
              <ol style="font-size:11px">
                <li>
                    Valitse yritys ja sen jälkeen kontakti jolle haluat lähettää tarjouksen.
                </li>
                <li>
                    Valitse tarjouspohja jota haluat käyttää. Tarjouspohjat ovat valmiita tarjouksia jossa on tuotteet ja tarjoustiedot valmiina, mutta yritystä ja kontaktia ei ole näihin lisätty.
                </li>
                <li>
                    Muokkaa tarjouspohjaa sellaiseksi kuin haluat.
                </li>
                <li>
                    Kun olet lisännyt tiedot, niin paina lähetä testi. Tämä lähettää Avecor-sähköpostiisi tarjouksen, jonka voit vilkaista. Tämä vaihe ei ole pakollinen.
                </li>
                <li>
                    Paina "Lähetä tarjous". Tarjous lähetetään tilaajan sähköpostiin, joka on näkyvillä kun valitset kontaktin. Tarjouksesta lähtee myös kopio sinulle.
                </li>
              </ol>
              <h4 class="mt-3 mb-3">Tyhjästä</h4>
              <ol style="font-size:11px">
                <li>
                  Valitse yritys ja sit kontakti.
                </li>
                <li>
                  Jätä tarjouspohjan valinta tyhjäksi.
                </li>
                <li>
                  Lisää tyhjiin kenttiin tarvittavat tiedot. 
                </li>
                <li>
                  Lisää tuote valitsemalla tuotteen Avecorin tuotekatalogista.
                </li>
                <li>
                  Valitse tuotteelle kuva (ei pakollinen). Mikäli kuvaa tuotteelle ei vielä ole voit pyytää toimistoa lisäämään tai lisätä järjestelmään tuotteesta kuvan. Kuvien tulisi olla hyvän laatuisia. Voit myös kopioda kuvan toiselta sivulta oikea-klikkaamalla ja valitsemalla kopioi kuva. 
                  Tämän jälkeen voit klikata "Paste" nappia kuvien lisäyksen alta, jonka jälkeen järjestelmä lisään sen.
                </li>
                <li>
                  Lisää tuotteelle tekstit ja hintatiedot.
                </li>
                <li>
                  Oikealta puolelta voit tarkkailla miltä tarjous näyttää samalla kun teet muutoksia. Tekstikenttien osalta tekstit päivittyvät preview-näkymään aina kun klikkaat ulos kentästä tai seuraavaan kenttään.
                </li>

              </ol>
            </div> 
            <v-container ma-0 pa-0 class="avecor-new-promotion-container">
              <v-row no-gutters class="my-6 mx-3">
                <v-col sm="4" class="pr-3 text-left">
                  <v-btn @click="resetPromotion()" class="avecor-button-global mr-6" >Tyhjennä</v-btn>
                </v-col>
                <v-col sm="8" class="pr-3 text-right">    
                  <!-- <v-btn @click="getHTML()" class="add-button avecor-button-global mr-3" >HTML</v-btn> -->
                  <v-btn @click="sendTestPromotion()" class="add-button avecor-button-global mr-3" >Lähetä testi omaan sähköpostiin</v-btn>
                  <v-btn color="success" @click="validateAndCreatePromotion()" tile>Lähetä tarjous</v-btn>
                </v-col>
              </v-row>
              <!-- <v-row no-gutters class="pa-5">
                
                <v-col sm="4" class="pr-3">
                    <v-autocomplete
                      v-model="selectedExistingPromotionId"
                      :items="promotions"
                      label="Valitse aikasemmin lähetetty tarjous (ei pakollinen)"
                      hint=""
                      placeholder=" "
                      item-text="text"
                      item-value="value"
                      @change="existingPromotionFieldChanged"
                      chips
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :input-value="data.selected"
                          close
                          small
                          solo
                          class="chip--select-multi"
                          @click:close="removeExistingPromotionSelection()"
                        >
                          {{ data.item.text.substr(0,500) }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                </v-col>
                <v-col sm="8" class="text-right">
                  <v-btn style="color:white;" class="add-button avecor-button-global mr-3" @click="showInstructions = !showInstructions">{{showInstructions ? "Sulje ohjeet" : "Näytä ohjeet"}}</v-btn>
                  <v-btn @click="resetPromotion()" class="add-button avecor-button-global mr-3" >Tyhjennä</v-btn>
                  <v-btn @click="sendTestPromotion()" class="add-button avecor-button-global mr-3" >Lähetä testi</v-btn>
                  <v-btn color="success" @click="validateAndCreatePromotion()" tile>Lähetä tarjous</v-btn>
                </v-col>
              </v-row> -->
              <v-divider></v-divider>
              <v-row no-gutters class="">
                <v-tabs
                  fixed-tabs
                  height="30"
                  v-model="selectedSendType"
                  class="mb-3"
                  style="border-bottom:1px solid #ccc;"
                >
                  <v-tabs-slider color="#81B1FF"></v-tabs-slider>
                  <v-tab href="#sendToOne" :style="selectedSendType === 'sendToOne' ? 'color:#81B1FF' : 'color:#333'" >Lähetä yhdelle kontaktille</v-tab>
                  <v-tab href="#sendToList" :style="selectedSendType === 'sendToList' ? 'color:#81B1FF' : 'color:#333'">Lähetä listalle</v-tab>
                </v-tabs>
                <div v-if="selectedSendType === 'sendToOne'" style="width:100%"><!--value="sendToOne"  -->
                  <v-row no-gutters class="ma-3">
                    <v-col sm="3" class="pr-3">
                      <v-autocomplete
                        v-model="selectedCompanyId"
                        :items="getCompanies"
                        label="Etsi yrityksiä"
                        placeholder=" "
                        autocomplete="off"
                        item-text="text"
                        item-value="value"
                        @change="companyFieldChanged"
                        chips
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :input-value="data.selected"
                            close
                            small
                            solo
                            class="chip--select-multi"
                            @click:close="removeCompanySelection()"
                          >
                            {{ data.item.text.substr(0,20) }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col sm="3" class="pr-3">
                      <v-text-field
                        label="Yrityksen nimi*"
                        placeholder=" "
                        :error-messages="errors.companyName"
                        @blur="fieldUpdated('companyName')"
                        @keyup="fieldUpdated('companyName')"
                        :value="companyName" 
                        @change="v => companyName = v"/>
                    </v-col>
                    <v-col sm="1" class="pr-3">
                      <v-text-field
                        label="Y-tunnus*"
                        placeholder=" "
                        v-model="companyId" />
                    </v-col>
                    <v-col sm="2" class="pr-3">
                      <v-text-field
                        label="Toimitusosoite*"
                        placeholder=" "
                        :error-messages="errors.deliveryAddress"
                        @blur="fieldUpdated('deliveryAddress')"
                        @keyup="fieldUpdated('deliveryAddress')"
                        v-model="deliveryAddress" />
                    </v-col>
                    <v-col sm="1" class="pr-3">
                      <v-text-field
                        label="Postikoodi*"
                        placeholder=" "
                        :error-messages="errors.deliveryPostalCode"
                        @blur="fieldUpdated('deliveryPostalCode')"
                        @keyup="fieldUpdated('deliveryPostalCode')"
                        v-model="deliveryPostalCode" />
                    </v-col>
                    <v-col sm="1" class="pr-3">
                      <v-text-field
                        label="Toimipaikka*"
                        placeholder=" " 
                        :error-messages="errors.deliveryCity"
                        @blur="fieldUpdated('deliveryCity')"
                        @keyup="fieldUpdated('deliveryCity')"
                        v-model="deliveryCity" />
                    </v-col>
                    <v-col sm="1">
                      <v-text-field
                        label="Maa*"
                        placeholder=" " 
                        :error-messages="errors.deliveryCountry"
                        @blur="fieldUpdated('deliveryCountry')"
                        @keyup="fieldUpdated('deliveryCountry')"
                        v-model="deliveryCountry" />
                    </v-col>
                    <v-col sm="3" class="pr-3">
                      <v-autocomplete
                        v-model="selectedContactId"
                        :items="getContacts"
                        label="Valitse kontakti"
                        placeholder=" "
                        autocomplete="off"
                        item-text="text"
                        item-value="value"
                        @change="contactFieldChanged"
                        chips
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :input-value="data.selected"
                            small
                            close
                            class="chip--select-multi"
                            @click:close="removeContactSelection()"
                          >
                            {{ data.item.text.substr(0,20) }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col sm="2" class="pr-3">
                      <v-text-field
                        label="Etunimi*"
                        placeholder=" "
                        :error-messages="errors.firstName"
                        v-model="firstName"
                        @blur="fieldUpdated('firstName')"
                        @keyup="fieldUpdated('firstName')"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="2" class="pr-3">
                      <v-text-field
                        label="Sukunimi*"
                        placeholder=" "
                        :error-messages="errors.lastName"
                        @blur="fieldUpdated('lastName')"
                        @keyup="fieldUpdated('lastName')"
                        v-model="lastName"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="2" class="pr-3">
                      <v-text-field
                        label="Tilaajan puhelinnumero*"
                        placeholder=" "
                        :error-messages="errors.clientPhone"
                        @blur="fieldUpdated('clientPhone')"
                        @keyup="fieldUpdated('clientPhone')"
                        v-model="clientPhone"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="3" >
                      <v-text-field
                        label="Tilaajan sähköpostiosoite*"
                        placeholder=" "
                        :error-messages="errors.clientEmail"
                        @blur="fieldUpdated('clientEmail')"
                        @keyup="fieldUpdated('clientEmail')"
                        v-model="clientEmail"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" class="">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="selectedSendType === 'sendToList'" style="width:100%"><!--  value="sendToList" -->
                  <v-row no-gutters class="ma-3">
                    <v-col offset="4" cols="4" class="pr-3 text-center">
                      <span style="font-size:10px;color:#333; font-style:italic;">Voit luoda listoja "Listat" välilehden kautta.</span>
                    </v-col>
                    
                  </v-row>
                  <v-row no-gutters class="ma-3">
                    <v-col offset="4" cols="4" class="pr-3">
                      <v-autocomplete
                        v-model="selectedListToSendTo"
                        :items="Object.keys(getLists).reduce((result,key) => {result.push({text:lists[key].name,value:lists[key].id}); return result},[])"
                        label="Valitse lista"
                        placeholder=" "
                        :error-messages="errors.selectedList"
                        item-text="text"
                        item-value="value"
                        autocomplete="off"
                        chips
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :input-value="data.selected"
                            close
                            small
                            solo
                            class="chip--select-multi"
                            @click:close="() => selectedListToSendTo = ''"
                          >
                            {{ data.item.text.substr(0,20) }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" class="">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </div>
              </v-row>
              <v-row no-gutters class="mx-3 my-6">
                <v-col sm="8" class="pr-3 text-left">
                  <v-text-field
                    class="hide-field-details"  
                    label="Uuden tarjouspohjan nimi"
                    placeholder=" "
                    :value="newPromotionTemplateName"
                    @change="v => newPromotionTemplateName = v" />
                </v-col>
                <v-col sm="4" class="text-right">
                  <v-btn color="#000000" @click="createPromotionTemplate()" tile dark class="add-button avecor-button-global">Tallenna uudeksi tarjouspohjaksi</v-btn>  
                </v-col>
              </v-row>
              <v-row no-gutters class="mx-3 mt-3 mb-3">
                <v-col sm="4" class="pr-3" >
                  <v-autocomplete
                    v-model="selectedPromotionTemplateId"
                    :items="getPromotionTemplates"
                    label="Valitse tallennettu tarjouspohja (ei pakollinen)"
                    hint=""
                    placeholder=" "
                    item-text="text"
                    item-value="value"
                    autocomplete="off"
                    @change="promotionTemplateFieldChanged"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        small
                        solo
                        class="chip--select-multi"
                        @click:close="removePromotionTemplateSelection()"
                      >
                        {{ data.item.text.substr(0,500) }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="4" class="pr-3">
                  <v-text-field
                    label="Tarjouspohjan nimi"
                    placeholder=" "
                    :disabled="selectedPromotionTemplateId === ''" 
                    :value="promotionTemplateName"
                    @change="v => promotionTemplateName = v" />
                </v-col>
                <v-col sm="4" class="text-right">
                  <v-row no-gutters>
                    <v-col cols="5" class="text-right">
                      <v-btn v-if="this.selectedPromotionTemplateId !== ''" color="#000000" @click="deletePromotionTemplate(selectedPromotionTemplateId); removePromotionTemplateSelection()" class="add-button avecor-button-global mt-2">Poista</v-btn>
                    </v-col>
                    <v-col cols="7">
                      <v-btn v-if="this.selectedPromotionTemplateId !== ''" color="#000000" @click="updatePromotionTemplate()" class="add-button avecor-button-global mt-2">Tallenna muutokset</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- <v-row no-gutters class="mr-3 ml-3 mt-3 mb-3">
                <v-col sm="3" class="pr-3" >
                  <v-autocomplete
                    v-model="selectedPromotionTemplateId"
                    :items="getPromotionTemplates"
                    label="Valitse tarjouspohja (ei pakollinen)"
                    hint=""
                    :disabled="selectedExistingPromotionId !== undefined && selectedExistingPromotionId !== ''" 
                    placeholder=" "
                    item-text="text"
                    item-value="value"
                    @change="promotionTemplateFieldChanged"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        small
                        solo
                        class="chip--select-multi"
                        @click:close="removePromotionTemplateSelection()"
                      >
                        {{ data.item.text.substr(0,500) }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="2" class="pr-3">
                  <v-text-field
                    label="Tarjouspohjan nimi"
                    placeholder=" "
                    :value="promotionTemplateName"
                    @change="v => promotionTemplateName = v" />
                </v-col>
                <v-col sm="7">
                  <v-row no-gutters>
                    <v-col cols="2">
                      <v-btn v-if="this.selectedPromotionTemplateId !== ''" color="#000000" @click="deletePromotionTemplate(selectedPromotionTemplateId); removePromotionTemplateSelection()" class="add-button avecor-button-global mt-2">Poista</v-btn>
                    </v-col>
                    <v-col cols="5">
                      <v-btn v-if="this.selectedPromotionTemplateId !== ''" color="#000000" @click="updatePromotionTemplate()" class="add-button avecor-button-global mt-2">Tallenna muutokset pohjaan</v-btn>
                    </v-col>
                    <v-col cols="5">
                      <v-btn color="#000000" @click="createPromotionTemplate()" tile dark class="add-button avecor-button-global mt-2">Tallenna uudeksi tarjouspohjaksi</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row> -->
              <v-divider></v-divider>
              <v-row no-gutters class="mr-3 ml-3 mt-3">
                <v-col sm="5" class="pr-3">
                  <v-text-field
                    label="Sähköpostin otsikko (näkyy sähköpostiohjelmassa)"
                    placeholder=" "
                    :value="promotionEmailSubject" 
                    @change="v => promotionEmailSubject = v"/>
                </v-col>
                <v-col sm="5" class="pr-3">
                  <v-text-field
                    label="Viestin otsikko"
                    placeholder=" "
                    :value="promotionMainHeadline" 
                    @change="v => promotionMainHeadline = v"/>
                </v-col>
                <v-col sm="2">
                  <v-menu
                    :nudge-right="40"
                    transition="fade-transition"
                    offset-y
                    min-width="30px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        label="Tarjous voimassa"     
                        v-model="promotionValidDate"
                        readonly
                      ></v-text-field>
                    </template>
                    
                    <v-date-picker v-model="promotionValidDate"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row no-gutters class="mr-3 ml-3 mt-3">
                <v-col sm="12">
                  <v-textarea
                    label="Viestin pääteksti (otsikon alla)"
                    placeholder=" "
                    :auto-grow="autogrow"
                    rows=1
                    :value="promotionMainSubHeader" 
                    @change="v => promotionMainSubHeader = v"/>
                </v-col>
              </v-row>
            </v-container>
            
            <div class="ma-2">  
              <NewPromotionProducts ref="newPromotionProducts"></NewPromotionProducts>
            </div>
          </v-col>
          <v-col cols="12" sm="6" class="pt-3" style="border-left:1px dotted #ccc;height:91.3vh;overflow-y:scroll;" >
            <v-row no-gutters>
              <v-col xs12 class="text-center">
                <v-btn-toggle
                  v-model="previewDevice"
                  tile 
                >
                  <v-btn value="mobile" class="avecor-button-global" height="40" >
                    <span class="hidden-sm-and-down">Mobiili</span>
                    <v-icon size=14 right>fas fa-mobile-alt</v-icon>
                  </v-btn>
                  <v-btn value="desktop" class="avecor-button-global" height="40" >
                    <span class="hidden-sm-and-down">Pöytäkone</span>
                    <v-icon size=14 right>fas fa-desktop</v-icon>
                  </v-btn>
                  <!-- <v-btn value="pdf" class="avecor-button-global" height="40" >
                    <span class="hidden-sm-and-down">PDF</span>
                    <v-icon size=14 right>fas fa-file-pdf</v-icon>
                  </v-btn> -->
                </v-btn-toggle>
                <!-- <v-btn @click="downloadAsPDF()" class="avecor-button-global ml-4">
                  <span class="hidden-sm-and-down">Lataa Tarjous</span>
                  <v-icon size=14 right>fas fa-download</v-icon>
                </v-btn> -->
              </v-col>
            </v-row>
            <v-row no-gutters style="padding-top:30px;" >
              <v-col class="text-center ma-5">
                <div id="promotionEmailPreview" :style="previewDevice === 'mobile' ? 'width:400px; margin:0 auto;' : 'max-width:1000px; width:100%'" ref="promotionEmailPreview">
                  
                </div>
                <div style="display:none">
                  <div id="promotionEmailPreviewForCanvas" style="'margin:0 auto;'" ref="promotionEmailPreviewForCanvas" />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs>
    <div class="text-center ma-12" v-if="bulkSendingActive" style="position:fixed; bottom:50px; right:50px;">
      <v-progress-circular
        :rotate="0"
        :size="50"
        :value="bulkSendPercentage"
        max="360"
        type="number"
        min="0"
        :width="6"
        color="light-blue"
      >{{ bulkSendNumber }}</v-progress-circular>
    </div>
  </v-container>  
</template>

<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import avecorLibrary from './../../js/avecorLibrary.js'
import html2pdf from 'html2pdf.js'
//import html2canvas from 'html2canvas'
import firebase from 'firebase'
import axios from 'axios'
import { jsPDF } from "jspdf";
var db = null

import PromotionResultsTable from './../../components/blocks/PromotionResultsTable'
import NewPromotionProducts from './../../components/blocks/NewPromotionProducts'

export default {
    components: {
      PromotionResultsTable,
      NewPromotionProducts
    },
    data () {
      return {
        productEdited:0,
        clickedSave:false,
        newPromotionTemplateName: '',
        selectedPromotionTab: 'promotionPDFGenerator', //'promotionCreator'
        selectedSendType:'sendToOne',
        selectedPromotionIdForResults:"",
        previewDevice: 'mobile',
        lists:{},
        selectedList:'',
        selectedListToSendTo:'',
        selectedContactIdForList:'',
        selectedCompanyIdForList:'',
        bulkSendingActive:false,
        bulkSendPercentage:0,
        bulkSendNumber:0,
        showInstructions:false,
        clipped: true,
        right: true,
        miniVariant: true,
        autogrow:true,
        content:"",
        orderSummary:'',
        orderSummaryIds:'',
        errors: {
          selectedList:'',
          billingEmail:'',
          companyName:"",
          deliveryAddress:"",
          deliveryPostalCode:"",
          deliveryCity:"",
          deliveryCountry:"",
          eBillingOperator: '',
          eBillingAddress: '',
          firstName:"",
          lastName:"",
          clientPhone:"",
          clientEmail:"",
        },
        addExistingContacterrors:{
          company:"",
          contact:""
        },
        listErrors: {
          companyName:"",
          deliveryAddress:"",
          deliveryPostalCode:"",
          deliveryCity:"",
          deliveryCountry:"",
          firstName:"",
          lastName:"",
          clientPhone:"",
          clientEmail:"",
        },
        list:{
          firstName:"",
          lastName:"",
          clientPhone:"",
          clientEmail:"",
          companyName:"",
          companyId:"",
          deliveryAddress:"",
          deliveryPostalCode:"",
          deliveryCity:"",
          deliveryCountry:"Finland",
        },
        emailTestPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        isMounted: false,
        isLoaded: false,
        promotions:[],
        promotionsMap:{},
        promotionTemplatesMap:{},
        promotionTemplates:[]
      }
    },
    watch: {
      previewDevice: {
        handler: function(val){
          console.log(this.previewDevice)
          this.generatePreview()
        },
      },
      selectedPromotionTab:{
        handler: function(val){
          if (val === "promotionPDFGenerator" || val === "promotionPDFGeneratorOld" || val === "promotionCreator") {
            //console.log("SELECTED TAB" + val )
            //console.log(this.previewDevice)
            this.generatePreview()
          }
        },
      },
      newPromotionDetails:{
        handler: function(val){
          if (this.selectedPromotionTab === "promotionPDFGenerator" || this.selectedPromotionTab === "promotionPDFGeneratorOld" || this.selectedPromotionTab === "promotionCreator") {
            console.log("PROMOTION DETAILS WATCH")
            this.generatePreview()
          }
          //console.log(val)
        },
        deep: true
      },
      isLoaded:{
        handler: function(val){
          if (val) {
            this.generatePreview()
          }
        }
      },
      product1:{handler: function(val){this.productEdited = 1; /* this.generatePreview() */},deep: true},
      product2:{handler: function(val){this.productEdited = 2; /* this.generatePreview() */},deep: true},
      product3:{handler: function(val){this.productEdited = 3; /* this.generatePreview() */},deep: true},
      product4:{handler: function(val){this.productEdited = 4; /* this.generatePreview() */},deep: true},
      product5:{handler: function(val){this.productEdited = 5; /* this.generatePreview() */},deep: true},
      product6:{handler: function(val){this.productEdited = 6; /* this.generatePreview() */},deep: true},
      product7:{handler: function(val){this.productEdited = 7; /* this.generatePreview() */},deep: true},
      product8:{handler: function(val){this.productEdited = 8; /* this.generatePreview() */},deep: true},
      product9:{handler: function(val){this.productEdited = 9; /* this.generatePreview() */},deep: true},
      product10:{handler: function(val){this.productEdited = 10; /* this.generatePreview() */},deep: true},
      product11:{handler: function(val){this.productEdited = 11; /* this.generatePreview() */},deep: true},
      product12:{handler: function(val){this.productEdited = 12; /* this.generatePreview() */},deep: true},
      product13:{handler: function(val){this.productEdited = 13; /* this.generatePreview() */},deep: true},
      product14:{handler: function(val){this.productEdited = 14; /* this.generatePreview() */},deep: true},
      product15:{handler: function(val){this.productEdited = 15; /* this.generatePreview() */},deep: true},
      product16:{handler: function(val){this.productEdited = 16; /* this.generatePreview() */},deep: true},
      product17:{handler: function(val){this.productEdited = 17; /* this.generatePreview() */},deep: true},
      product18:{handler: function(val){this.productEdited = 18; /* this.generatePreview() */},deep: true},
      product19:{handler: function(val){this.productEdited = 19; /* this.generatePreview() */},deep: true},
      product20:{handler: function(val){this.productEdited = 20; /* this.generatePreview() */},deep: true},
      'newPromotionDetails.promotionMainSubHeader':{
        handler: function(val){
          this.productEdited = 0
          //this.generatePreview()
        },
      }, 
    },
    mounted() {
      this.isMounted = true;
      db = firebase.firestore();
      var t = this
      if(t.staff[t.user.uid].role === "sales" && !t.staff[t.user.uid].isAdmin) {
        db.collection("promotionTemplates").where("created_by", "==", t.user.uid).onSnapshot(function(querySnapshot) {
          t.promotionTemplates = []
          querySnapshot.forEach(function(doc) {
              var data = doc.data()
              t.promotionTemplates.push({ text:data.promotionTemplateName, value:doc.id});
              t.promotionTemplatesMap[doc.id] = data
          });
        })
        db.collection("promotions").where("created_by", "==", t.user.uid).onSnapshot(function(querySnapshot) {
          t.promotions = []
          querySnapshot.forEach(function(doc) {
              var data = doc.data()
              if (t.companies[data.companyId] !== undefined){
                var text = t.customFormatter(data.created_at) + ':' + t.staff[data.created_by].firstName +' - ' + t.companies[data.companyId].companyName + ':' + data.promotionEmailSubject
                t.promotions.push({ text, value:doc.id, ...data});
                t.promotionsMap[doc.id] = {...doc.data()}
              }
          });
          t.promotions = t.promotions.sort(function(a,b){
            var aDate = a.created_at.seconds
            var bDate = b.created_at.seconds
            return bDate - aDate;
          });
          t.isLoaded = true
        })
        
      }
      else if(t.staff[t.user.uid].role === "office" || t.staff[t.user.uid].isAdmin) {
        db.collection("promotionTemplates").onSnapshot(function(querySnapshot) {
          t.promotionTemplates = []
          querySnapshot.forEach(function(doc) {
              var data = doc.data()
              t.promotionTemplates.push({ text:data.promotionTemplateName, value:doc.id});
              t.promotionTemplatesMap[doc.id] = data
              if (doc.id !== ""){
                //doc.id === t.selectedPromotionTemplateId ? t.promotionTemplateFieldChanged() : ""
              }
          });
        })
        db.collection("promotions").onSnapshot(function(querySnapshot) {
          t.promotions = []
          querySnapshot.forEach(function(doc) {
              var data = doc.data()
              if (t.companies[data.companyId] !== undefined){
                var text = t.customFormatter(data.created_at) + ' - ' + t.companies[data.companyId].companyName + ' - ' + data.promotionEmailSubject
                t.promotions.push({ text, value:doc.id, ...data});
                t.promotionsMap[doc.id] = {...doc.data()}
              }
              else {
                //console.log(data)
              }
          });
          t.promotions = t.promotions.sort(function(a,b){
            var aDate = a.created_at.seconds
            var bDate = b.created_at.seconds
            return bDate - aDate;
          });
          t.isLoaded = true
        })
      }
      if(t.staff[t.user.uid].role === "sales" && !t.staff[t.user.uid].isAdmin) {
        db.collection("lists").where("created_by", "==", t.user.uid)
          .onSnapshot(function(querySnapshot) {
            t.lists = {}
            querySnapshot.forEach(function(doc) {
                t.lists[doc.id] = {...doc.data()}
            });
        })
      }
      else if(t.staff[t.user.uid].role === "office" || t.staff[t.user.uid].isAdmin) {
        db.collection("lists")
          .onSnapshot(function(querySnapshot) {
            t.lists = {}
            querySnapshot.forEach(function(doc) {
                t.lists[doc.id] = {...doc.data()}
            });
        })
      }
      
      
    },
    computed: {
      
      product1(){if(this.newPromotionDetails.products[0]){return this.newPromotionDetails.products[0]}},
      product2(){if(this.newPromotionDetails.products[1]){return this.newPromotionDetails.products[1]}},
      product3(){if(this.newPromotionDetails.products[2]){return this.newPromotionDetails.products[2]}},
      product4(){if(this.newPromotionDetails.products[3]){return this.newPromotionDetails.products[3]}},
      product5(){if(this.newPromotionDetails.products[4]){return this.newPromotionDetails.products[4]}},
      product6(){if(this.newPromotionDetails.products[5]){return this.newPromotionDetails.products[5]}},
      product7(){if(this.newPromotionDetails.products[6]){return this.newPromotionDetails.products[6]}},
      product8(){if(this.newPromotionDetails.products[7]){return this.newPromotionDetails.products[7]}},
      product9(){if(this.newPromotionDetails.products[8]){return this.newPromotionDetails.products[8]}},
      product10(){if(this.newPromotionDetails.products[9]){return this.newPromotionDetails.products[9]}},
      product11(){if(this.newPromotionDetails.products[10]){return this.newPromotionDetails.products[10]}},
      product12(){if(this.newPromotionDetails.products[11]){return this.newPromotionDetails.products[11]}},
      product13(){if(this.newPromotionDetails.products[12]){return this.newPromotionDetails.products[12]}},
      product14(){if(this.newPromotionDetails.products[13]){return this.newPromotionDetails.products[13]}},
      product15(){if(this.newPromotionDetails.products[14]){return this.newPromotionDetails.products[14]}},
      product16(){if(this.newPromotionDetails.products[15]){return this.newPromotionDetails.products[15]}},
      product17(){if(this.newPromotionDetails.products[16]){return this.newPromotionDetails.products[16]}},
      product18(){if(this.newPromotionDetails.products[17]){return this.newPromotionDetails.products[17]}},
      product19(){if(this.newPromotionDetails.products[18]){return this.newPromotionDetails.products[18]}},
      product20(){if(this.newPromotionDetails.products[19]){return this.newPromotionDetails.products[19]}},
      product21(){if(this.newPromotionDetails.products[20]){return this.newPromotionDetails.products[20]}},
      getLists(){
        return this.lists
      },
      getBillingFormats(){
        var billingFormats = this.settings.billingFormats
        return Object.keys(this.settings.billingFormats).reduce(function(result, key) {
          result.push({...billingFormats[key]});
          return result;
        }, []);
      },
      getCompanies(){
        var t = this
        return Object.keys(this.companies).reduce((result,key) => {
          var c = t.companies[key]
          if(t.staff[t.user.uid].role === "sales" && !t.staff[t.user.uid].isAdmin) {
            c.salesperson === t.user.uid ? result.push({text: c.companyName, value: c.id}) : ''
          }
          else result.push({text: c.companyName, value: c.id})
          return result
        },[])
      },
      getPromotionTemplates(){
        return this.promotionTemplates.sort((a,b)=>{
          var nameA= a.text.toLowerCase(), nameB=b.text.toLowerCase();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })
      },
      getContacts(){
        var contacts = this.contacts
        var selectedCompanyId = this.selectedCompanyId
        var filteredContacts = []
        Object.keys(this.contacts).reduce(function(acc, key) {
          var c = contacts[key]
          if(c.companyId === selectedCompanyId) filteredContacts.push({text: c.firstName+" "+c.lastName, value: c.id})
          return acc + 1
        },0)
        return filteredContacts
      },
      getContactsForList(){
        var contacts = this.contacts
        var selectedCompanyId = this.selectedCompanyIdForList
        var filteredContacts = []
        Object.keys(this.contacts).reduce(function(acc, key) {
          var c = contacts[key]
          if(c.companyId === selectedCompanyId) filteredContacts.push({text: c.firstName+" "+c.lastName, value: c.id})
          return acc + 1
        },0)
        return filteredContacts
      },
      ...mapFields({
        companies:'company.companies',
        orders:'order.orders',
        productCatalog:'product.products',
        orderedProducts:'orderedProduct.orderedProducts',
        staff:'staff.staff',
        contacts:'contact.contacts',
        productVariations:'productVariation.productVariations',
        isAuthenticated:'settings.isAuthenticated',
        isSales:'settings.isSales',
        isOffice:'settings.isOffice',
        officeView:'selectedView.officeView',
        salesView:'selectedView.salesView',
        clientView:'selectedView.clientView',
        clientNameTags:'clientNameTags',
        settings:'settings',
        signInLoader:'settings.signInLoader',
        user:'user',
        newPromotionDetails:'newPromotionDetails',
        promotionEmailSubject:'newPromotionDetails.promotionEmailSubject',
        promotionMainHeadline:'newPromotionDetails.promotionMainHeadline',
        promotionMainSubHeader:'newPromotionDetails.promotionMainSubHeader',
        promotionValidDate:'newPromotionDetails.promotionValidDate',
        promotionTemplateName:'newPromotionDetails.promotionTemplateName',
        selectedExistingPromotionId:'newPromotionDetails.selectedExistingPromotionId',
        selectedPromotionTemplateId:'newPromotionDetails.selectedPromotionTemplateId',
        selectedCompanyId:'newPromotionDetails.selectedCompanyId',
        selectedContactId:'newPromotionDetails.selectedContactId',
        selectedProductId:'newPromotionDetails.selectedProductId',
        existingCompanySelected:'newPromotionDetails.existingCompanySelected',
        existingProductSelected:'newPromotionDetails.existingProductSelected',
        existingContactSelected:'newPromotionDetails.existingContactSelected',
        differentBillingAddress:'newPromotionDetails.differentBillingAddress',
        differentBillingEmail:'newPromotionDetails.differentBillingEmail',
        billingEInvoiceNumber:'newPromotionDetails.billingEInvoiceNumber',
        eBillingAddress:'newPromotionDetails.eBillingAddress',
        eBillingOperator:'newPromotionDetails.eBillingOperator',
        billingEmail:"newPromotionDetails.billingEmail",
        billingFormat:"newPromotionDetails.billingFormat",
        salesperson:"newPromotionDetails.salesperson",
        clientName:"newPromotionDetails.clientName",
        firstName:"newPromotionDetails.firstName",
        lastName:"newPromotionDetails.lastName",
        clientPhone:"newPromotionDetails.clientPhone",
        clientEmail:"newPromotionDetails.clientEmail",
        sendConfirmation:"newPromotionDetails.sendConfirmation",
        additionalCustomerInformation:"newPromotionDetails.additionalCustomerInformation",
        clientOrderDetailsEmail:"newPromotionDetails.clientOrderDetailsEmail",
        clientPrintDetailsEmail:"newPromotionDetails.clientPrintDetailsEmail",
        companyName:"newPromotionDetails.companyName",
        companyId:"newPromotionDetails.companyId",
        deliveryAddress:"newPromotionDetails.deliveryAddress",
        deliveryPostalCode:"newPromotionDetails.deliveryPostalCode",
        deliveryCity:"newPromotionDetails.deliveryCity",
        deliveryCountry:"newPromotionDetails.deliveryCountry",
        billingAddress:"newPromotionDetails.billingAddress",
        billingPostalCode:"newPromotionDetails.billingPostalCode",
        billingCity:"newPromotionDetails.billingCity",
        billingCountry:"newPromotionDetails.billingCountry",
        billingReferenceDetails:"newPromotionDetails.billingReferenceDetails",
        seperateBillingAddress:"newPromotionDetails.seperateBillingAddress",
        paymentTerm:"newPromotionDetails.paymentTerm",
        orderDate:"newPromotionDetails.orderDate",
        orderReference:"newPromotionDetails.orderReference",
        orderDeliveryMethod:"newPromotionDetails.orderDeliveryMethod",
        orderComments:"newPromotionDetails.orderComments",
        sendOrderCommentsInConfirmation:"newPromotionDetails.sendOrderCommentsInConfirmation",
        deliveryCharges:"newPromotionDetails.deliveryCharges"
      }),
      ...mapMultiRowFields({
        products: "newPromotionDetails.products",
        productsErrors: "newPromotionDetails.productsErrors"
      })
    },
    created () {},
    methods: {
      addContactToList(){
        var errors = false
        if(this.selectedContactIdForList === '') {this.addExistingContacterrors.contact = 'Täytä kenttä'; errors = true}
        if(this.selectedCompanyIdForList === '') {this.addExistingContacterrors.company = 'Täytä kenttä'; errors = true}
        if (errors) return
        const listRef = db.collection('lists').doc(this.selectedList).set({
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          contacts:firebase.firestore.FieldValue.arrayUnion({contactId:this.selectedContactIdForList,companyId:this.selectedCompanyIdForList}),
        }, { merge: true })
        this.selectedContactIdForList = ''
        this.selectedCompanyIdForList = ''
      },
      removeContactFromList(obj){
        const listRef = db.collection('lists').doc(this.selectedList).set({
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          contacts:firebase.firestore.FieldValue.arrayRemove({contactId:obj.contactId,companyId:obj.companyId}),
        }, { merge: true })
      },
      async addList(){
        const listRef = db.collection('lists').doc()
        const listId = listRef.id
        await listRef.set({
          id:listId,
          created_at:firebase.firestore.FieldValue.serverTimestamp(),
          created_by:this.user.uid,
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          name:'Uusi lista'
        })
      },
      deleteList(list){
        let deleteDoc = db.collection('lists').doc(this.selectedList).delete();
        this.selectedList = ''
      },
      updateListName(name){
        if(this.selectedList !== undefined && this.selectedList !== ''){
        db.collection('lists').doc(this.selectedList).set({
            updated_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_by:this.user.uid,
            name
          }, { merge: true })
        }
      },
      async createAndAddContactToList(){
        var errors = false
        if(this.list.companyName === '') { this.listErrors.companyName = 'Täytä'; errors = true}
        if(this.list.companyId === '') { this.listErrors.companyId = 'Täytä'; errors = true}
        if(this.list.deliveryAddress === '') { this.listErrors.deliveryAddress = 'Täytä'; errors = true}
        if(this.list.deliveryPostalCode === '') { this.listErrors.deliveryPostalCode = 'Täytä'; errors = true}
        if(this.list.deliveryCity === '') { this.listErrors.deliveryCity = 'Täytä'; errors = true}
        if(this.list.deliveryCountry === '') { this.listErrors.deliveryCountry = 'Täytä'; errors = true}
        if(this.list.firstName === '') { this.listErrors.firstName = 'Täytä'; errors = true}
        if(this.list.lastName === '') { this.listErrors.lastName = 'Täytä'; errors = true}
        if(this.list.clientPhone === '') { this.listErrors.clientPhone = 'Täytä'; errors = true}
        if(!this.emailTestPattern.test(this.list.clientEmail)) { this.listErrors.clientEmail = 'Syötä validi sähköposti'; errors = true}
        
        //console.log(errors)
        if (errors) return

        var companyData = {
          companyName:this.list.companyName,
          companyId:this.list.companyId,
          deliveryAddress:this.list.deliveryAddress,
          deliveryPostalCode:this.list.deliveryPostalCode,
          deliveryCity:this.list.deliveryCity,
          deliveryCountry:this.list.deliveryCountry,
          salesperson:this.user.uid,
        }
        var companyId = await this.$store.dispatch('company/set', companyData)
        this.$store.dispatch('company/batchSync')
        var contactData = {
          companyId:companyId,
          firstName:this.list.firstName,
          lastName:this.list.lastName,
          phone:this.list.clientPhone,
          email:this.list.clientEmail,
        }
        var contactId = await this.$store.dispatch('contact/set', contactData)
        this.$store.dispatch('contact/batchSync')
        const listRef = db.collection('lists').doc(this.selectedList).set({
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          contacts:firebase.firestore.FieldValue.arrayUnion({contactId,companyId}),
        }, { merge: true })
        
      },
      emptyAddContactToList(){
        var list = this.list
        var listErrors = this.listErrors
        Object.keys(list).forEach(key => {list[key] = ''})
        Object.keys(list).forEach(key => listErrors[key] = '')
        this.list.deliveryCountry = "Finland"
      },

      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      

      async generatePreview(){
        var previewDevice = this.previewDevice
        if(this.isLoaded){
          //console.log("IN PREVIEW GENERATION")
          
          if (this.selectedPromotionTab === "promotionCreator") {
            //this.$refs.promotionEmailPreview.innerHTML =await avecorLibrary.generatePromotionEmailHTML(this.newPromotionDetails, this.products, this.staff[this.user.uid],previewDevice)
            var content = await avecorLibrary.generatePromotionEmailHTML(this.newPromotionDetails, this.products, this.staff[this.user.uid],previewDevice)
            this.$refs.promotionEmailPreview !== undefined && this.$refs.promotionEmailPreview.innerHTML !== undefined ? this.$refs.promotionEmailPreview.innerHTML = content : ""
          }
          
          else if (this.selectedPromotionTab === "promotionPDFGeneratorOld") {
            var content = await avecorLibrary.generatePromotionEmailHTML(this.newPromotionDetails, this.products, this.staff[this.user.uid],'pdf')
            this.$refs.promotionPDFPreview !== undefined && this.$refs.promotionPDFPreview.innerHTML !== undefined ? this.$refs.promotionPDFPreview.innerHTML = content : ""
          }
          else if (this.selectedPromotionTab === "promotionPDFGenerator") {
            try{
              console.log("GENERATING PDF PREVIEW")
              var doc = new jsPDF({unit:'px',format:'a4'})
              var header = await avecorLibrary.getBase64("https://storage.googleapis.com/avecor-public/avecor%2Ftarjouspohja-kuva.jpg")
              var logo = await avecorLibrary.getBase64("https://storage.googleapis.com/avecor-public/avecor%2Favecor-logo-no-slogan-200x57.jpg")
              var page = this.productEdited
              
              var nop = this.newPromotionDetails.products.length
              //console.log(this.newPromotionDetails)
              var yPosition = 60
              for (var cp = 0; cp < nop; cp++){
                doc = this.addHeaderToPDF(doc,header,logo)
                yPosition = 60
                if(cp == 0){
                  var date = new Date()
                  var d = date.getDay()
                  var m = date.getMonth() + 1
                  var y = date.getFullYear()
                  //console.log(doc.getFont())
                  //var font = doc.getFont()
                  // DATE
                  doc.setTextColor(0, 0, 0) // Black
                  doc.setFontSize(12)
                  doc.setFont('helvetica',undefined,'400')
                  doc.text(40, yPosition, d+'.'+m+'.'+y )
                  yPosition = yPosition+30
                  var lineSplit = doc.splitTextToSize(this.newPromotionDetails.promotionMainSubHeader, 370);

                  for (var j = 0; j < lineSplit.length; j++){
                    doc.text(40, yPosition, lineSplit[j])
                    yPosition = yPosition + 12
                  }
                  doc.setFillColor(242, 101, 57)
                  doc.rect(0, yPosition, 455, 20, 'F')
                  doc.setTextColor(255, 255, 255) // White
                  yPosition = yPosition+12
                  doc.text(40, yPosition, 'Kiitos mielenkiinnostanne tuotteitamme kohtaa, joita tarjoamme teille seuraavasti:' )
                  yPosition = yPosition+20
                  if(lineSplit.length <= 7){
                    
                  }
                  if(lineSplit.length > 7){
                    doc = this.addFooterToPDF(doc)
                    doc.addPage()
                    doc = this.addHeaderToPDF(doc,header,logo)
                    yPosition = 60
                    if(this.productEdited !== 0)  page += 1
                  }
                }
                //PRODUCT NAME
                yPosition = yPosition+10
                var productName = ""
                var p =  this.newPromotionDetails.products[cp]
                if(p.customerProductName){ productName = p.customerProductName}
                else if (p.productName) { productName = p.productName }
                else if (p.productId && this.productCatalog[p.productId] && this.productCatalog[p.productId].name.fi) { productName = this.productCatalog[p.productId].name.fi}
                
                if(!productName) console.log('NO PRODUCT NAME')
                if(!productName) console.log(p)
                doc.setTextColor(0, 0, 0) // Black
                doc.setFont('helvetica','bold')
                doc.text(40, yPosition, productName ? productName.toUpperCase() : '' )

                // PRODUCT DESCRIPTION
                var productDescription = p.customerProductDescription
                doc.setFont('helvetica','normal')
                yPosition = yPosition + 20
                //doc.text(40, yPosition, productDescription)
                var lineSplit = doc.splitTextToSize(productDescription, 370);
                for (var j = 0; j < lineSplit.length; j++){
                  doc.text(40, yPosition, lineSplit[j])
                  yPosition = yPosition + 12
                }
                // OFFERS
                yPosition = yPosition + 10
                var offers = p.offers
                for (var i = 0; i < offers.length; i++){
                  var offer = offers[i]
                  if(offer.quantity && offer.unitPrice){
                    doc.text(40, yPosition, offer.quantity + 'kpl')
                    doc.text(40+50, yPosition, offer.unitPrice + '€/kpl')
                  }
                  yPosition = yPosition + 12
                }
                // PRODUCT NOTICE TEXT
                var productNoticeText = p.productNoticeText
                if(productNoticeText){
                  var lineSplit = doc.splitTextToSize(productNoticeText, 370);
                  for (var j = 0; j < lineSplit.length; j++){
                    doc.text(40, yPosition, lineSplit[j])
                    yPosition = yPosition + 12
                  }
                }

                // IMAGES
                yPosition = yPosition + 10
                var url1 = p.selectedFileUrl
                var url2 = p.selected2FileUrl
                var url3 = p.selected3FileUrl
                var imageSize = p.imageSize
                var image2Size = p.image2Size
                var image3Size = p.image3Size
                if(url1 && !url2){
                  url1 = url1.replace("https://firebasestorage.googleapis.com/v0/b/avecor-public/o/","https://storage.googleapis.com/avecor-public/")
                  url1 = url1.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/o/","https://storage.googleapis.com/avecor-internal/")
                  //url = url.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/","https://storage.googleapis.com/avecor-public/")
                  var height = 180
                  if(imageSize && imageSize === 'L') height += 100
                  if(imageSize && imageSize === 'M') height += 50
                  if(imageSize && imageSize === 'S') height += 0
                  
                  
                  var img = await this.addImageProcess(url1)
                  var r = img.width / img.height
                  var p1 = await avecorLibrary.toDataURL(url1)
                  doc.addImage(p1, "JPEG", 40, yPosition, height*r, height)
                  
                }
                else if(url1 && url2 && !url3){
                  url1 = url1.replace("https://firebasestorage.googleapis.com/v0/b/avecor-public/o/","https://storage.googleapis.com/avecor-public/")
                  url1 = url1.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/o/","https://storage.googleapis.com/avecor-internal/")
                  url2 = url2.replace("https://firebasestorage.googleapis.com/v0/b/avecor-public/o/","https://storage.googleapis.com/avecor-public/")
                  url2 = url2.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/o/","https://storage.googleapis.com/avecor-internal/")
                  //url = url.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/","https://storage.googleapis.com/avecor-public/")
                  var a1 = 0
                  var a2 = 0
                  var a3 = 0
                  if(imageSize && imageSize === 'L') a1 += 50
                  if(imageSize && imageSize === 'M') a1 += 25
                  if(imageSize && imageSize === 'S') a1 += 0
                  if(image2Size && image2Size === 'L') a2 += 50
                  if(image2Size && image2Size === 'M') a2 += 25
                  if(image2Size && image2Size === 'S') a2 += 0

                  
                  /* if(imageSize && imageSize === 'L') height += 100
                  if(imageSize && imageSize === 'M') height += 50
                  if(imageSize && imageSize === 'S') height += 0 */
                  var img1 = await this.addImageProcess(url1)
                  var img2 = await this.addImageProcess(url2)
                  var r1 = img1.width / img1.height
                  var r2 = img2.width / img2.height
                  var p1 = await avecorLibrary.toDataURL(url1)
                  var p2 = await avecorLibrary.toDataURL(url2)
                  var w1 = 140 + a1
                  var w2 = 140 + a2
                  var h1 = w1/r1
                  var h2 = w2/r2
                  doc.addImage(p1, "JPEG", 40, yPosition, w1, h1)
                  doc.addImage(p2, "JPEG", 200+a1, yPosition, w2, h2)
                  
                }
                else if(url1 && url2 && url3){
                  url1 = url1.replace("https://firebasestorage.googleapis.com/v0/b/avecor-public/o/","https://storage.googleapis.com/avecor-public/")
                  url1 = url1.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/o/","https://storage.googleapis.com/avecor-internal/")
                  url2 = url2.replace("https://firebasestorage.googleapis.com/v0/b/avecor-public/o/","https://storage.googleapis.com/avecor-public/")
                  url2 = url2.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/o/","https://storage.googleapis.com/avecor-internal/")
                  url3 = url3.replace("https://firebasestorage.googleapis.com/v0/b/avecor-public/o/","https://storage.googleapis.com/avecor-public/")
                  url3 = url3.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/o/","https://storage.googleapis.com/avecor-internal/")
                  //url = url.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/","https://storage.googleapis.com/avecor-public/")
                  
                  var a1 = 0
                  var a2 = 0
                  var a3 = 0
                  if(imageSize && imageSize === 'L') a1 += 50
                  if(imageSize && imageSize === 'M') a1 += 25
                  if(imageSize && imageSize === 'S') a1 += 0
                  if(image2Size && image2Size === 'L') a2 += 50
                  if(image2Size && image2Size === 'M') a2 += 25
                  if(image2Size && image2Size === 'S') a2 += 0
                  if(image3Size && image3Size === 'L') a3 += 50
                  if(image3Size && image3Size === 'M') a3 += 25
                  if(image3Size && image3Size === 'S') a3 += 0
                  var img1 = await this.addImageProcess(url1)
                  var img2 = await this.addImageProcess(url2)
                  var img3 = await this.addImageProcess(url3)
                  var r1 = img1.width / img1.height
                  var r2 = img2.width / img2.height
                  var r3 = img3.width / img3.height
                  var p1 = await avecorLibrary.toDataURL(url1)
                  var p2 = await avecorLibrary.toDataURL(url2)
                  var p3 = await avecorLibrary.toDataURL(url3)
                  var w1 = 140 + a1
                  var w2 = 140 + a2
                  var w3 = 140 + a3
                  var h1 = w1/r1
                  var h2 = w2/r2
                  var h3 = w3/r3
                  var ya = 0
                  if(h1 > h2) ya += h1 + 10
                  else ya += h2+10
                  doc.addImage(p1, "JPEG", 40, yPosition, w1, h1)
                  doc.addImage(p2, "JPEG", 200+a1, yPosition, w2, h2)
                  doc.addImage(p3, "JPEG", 40, yPosition+ya, w3, h3)
                  
                }
                doc = this.addFooterToPDF(doc)
                if(cp < nop-1) doc.addPage()
              }
              if(this.clickedSave){
                doc.save(d+'-'+m+'-'+y+'_Tarjous.pdf');
                this.clickedSave = false
              }
              
              var data = doc.output('bloburl')
              data += '#page='+page
              /* const FILE_NAME = 'myCoolFileName.pdf';
              const file_header = ';headers=filename%3D';
              data.replace(';', file_header + encodeURIComponent(FILE_NAME) + ';')
              console.log(data) */
              /* var pdfPreviewDoc = document.getElementById('pdfPreview')
              pdfPreviewDoc.src = data */
              //var data = doc.output('datauri')
              this.$refs['pdfPreview'].src = ""
              console.log(data)
              this.$refs['pdfPreview'] ? this.$refs['pdfPreview'].src = data : ''
            }
            catch(e){
              console.log(e.message)
            }
            
          }
        }
      },
      addHeaderToPDF(doc,header,logo){
        
        //console.log(logo)
        doc.addImage(header, 'jpeg', -70, -48, 585, 60)
        doc.addImage(logo, 'jpeg', 360, 20, 70, 20)
        //TARJOUS HEADER
        doc.setTextColor(242, 101, 57) // Avecor Orange
        doc.setFontSize(13)
        doc.text(40, 40, 'TARJOUS' )

        return doc
      },
      addFooterToPDF(doc){
        doc.setFillColor(242, 101, 57)
        doc.rect(0, 565, 455, 1, 'F')
        

        doc.setFontSize(10)
        doc.setTextColor(242, 101, 57) // Avecor Orange
        doc.setFont('helvetica')
        doc.text(30, 580, 'Avecor Oy' )
        doc.setTextColor(0, 0, 0) // Black
        doc.text(67, 580, 'Helsinki' )
        doc.setTextColor(242, 101, 57) // Avecor Orange
        doc.setFont('helvetica','bold')
        doc.text(95, 579, '|' )
        doc.setTextColor(0, 0, 0) // Black
        doc.setFont('helvetica','normal')
        doc.text(99, 580, 'Pori' )
        doc.setTextColor(242, 101, 57) // Avecor Orange
        doc.setFont('helvetica','bold')
        doc.text(114, 579, '|' )
        doc.setTextColor(0, 0, 0) // Black
        doc.setFont('helvetica','normal')
        doc.text(118, 580, 'Tampere' )
        doc.setFontSize(14)
        doc.text(150, 581, '•' )
        doc.setFontSize(10)
        doc.text(155, 580, 'puh. 010 4190160' )
        doc.setFontSize(14)
        doc.text(218, 581, '•' )
        doc.setFontSize(10)
        //doc.setFont('helvetica','underline')
        doc.setTextColor(118, 147, 142) // Teal link color
        doc.textWithLink('myynti@avecor.fi',225,580,{url:"mailto:myynti@avecor.fi"})
        doc.setTextColor(0, 0, 0) // Black
        doc.setFontSize(14)
        doc.text(286, 581, '•' )
        doc.setFontSize(10)
        doc.setTextColor(118, 147, 142) // Teal link color
        doc.textWithLink('www.avecor.fi',292,580,{url:"https://www.avecor.fi"})
        doc.setTextColor(0, 0, 0) // Black
        doc.setFontSize(14)
        doc.text(342, 581, '•' )
        doc.setFontSize(10)
        doc.text(347, 580, 'Y-tunnus: 2714868-9' )

        doc.setFontSize(8)
        doc.text(55, 595, 'Hintoihin lisätään voimassa oleva ALV. Maksuehto 14vrk. Maksun viivästyessä peritään korkolain mukainen viivästyskorko.' )
        doc.text(75, 605, 'Toimitusmaksu 24,90 €. Mahdolliset huomautukset on tehtävä 8 vrk kuluessa lähetyksen vastaanottamisesta.' )
        doc.text(100, 620, 'Verkkolaskutusosoite: 003727148689 • Operaattoritunnus: 003721291126 • Välittäjä: Maventa' )

        return doc
      },
      addImageProcess(src){
        return new Promise((resolve, reject) => {
          let img = new Image()
          img.onload = () => resolve({height:img.height,width:img.width})
          img.onerror = reject
          img.src = src
        })
      },
      async downloadAsPDF(){
        var element = document.getElementById('promotionPDFPreviewForCanvas');
        var t = this
        var d = new Date();
        var month = d.getMonth() + 1;
        month < 10 ? month = "0"+month : ""
        var year = d.getFullYear();
        element.innerHTML = await avecorLibrary.generatePromotionPDFHTML(t.newPromotionDetails, t.products, t.staff[t.user.uid])
        var opt = {
          //margin:       1,
          filename:     this.promotionEmailSubject+'-'+month+'_'+year,
          image:        { type: 'jpeg', quality: 1 },
          html2canvas:  { scale: 2 },
          //jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
        };
        html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();

          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(7);
            pdf.setTextColor(150);
            //console.log(pdf)
            //Page ' + i + ' of ' + totalPages
            pdf.text('Avecor Oy', 10, pdf.internal.pageSize.getHeight() - 18);
            pdf.text('Avecor.fi', 10, pdf.internal.pageSize.getHeight() - 15);
            pdf.text('010 419 2227', 10, pdf.internal.pageSize.getHeight() - 12);
            pdf.text('2714868-9', 10, pdf.internal.pageSize.getHeight() - 9);
          } 
        }).save();
        //html2pdf().set(opt).from(element).save();
      },
      customFormatter(date) {
        if(date === null || date === undefined){
          return ''
        }
        else if (date !== undefined && date.seconds !== undefined) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },

      resetPromotion(){
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
        this.$store.dispatch('resetPromotionProducts', "")
        this.selectedCompanyId = ''
        this.selectedContactId = ''
        this.selectedListToSendTo = ''
        this.selectedExistingPromotionId = ''
        this.existingCompanySelected = false
        this.existingContactSelected = false
        this.clientName = ""
        this.firstName = ""
        this.lastName = ""
        this.clientPhone = ""
        this.clientEmail = ""
        this.sendConfirmation = ""
        this.additionalCustomerInformation = ""
        this.clientOrderDetailsEmail = ""
        this.clientPrintDetailsEmail = ""
        this.companyName = ""
        this.companyId = ""
        this.deliveryAddress = ""
        this.deliveryPostalCode = ""
        this.deliveryCity = ""
        this.deliveryCountry = "Finland"
        this.deliveryCharges = "24.90"
        this.selectedPromotionTemplateId = ''
        this.promotionEmailSubject = ""
        this.promotionMainHeadline = ""
        this.promotionMainSubHeader = ""
        this.promotionTemplateName = ""
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
        this.$refs.newPromotionProducts.addProductToPromotion()
      },
      fieldUpdated(field){
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        field === "companyName" && this.companyName.trim() === "" ? this.errors.companyName = "Täytä" : null
        field === "companyName" && this.companyName.trim() !== "" ? this.errors.companyName = "" : null
        field === "deliveryAddress" && this.deliveryAddress.trim() === "" ? this.errors.deliveryAddress = "Täytä" : null
        field === "deliveryAddress" && this.deliveryAddress.trim() !== "" ? this.errors.deliveryAddress = "" : null
        field === "deliveryPostalCode" && this.deliveryPostalCode.trim() === "" ? this.errors.deliveryPostalCode = "Täytä" : null
        field === "deliveryPostalCode" && this.deliveryPostalCode.trim() !== "" ? this.errors.deliveryPostalCode = "" : null
        field === "deliveryCity" && this.deliveryCity.trim() === "" ? this.errors.deliveryCity = "Täytä" : null
        field === "deliveryCity" && this.deliveryCity.trim() !== "" ? this.errors.deliveryCity = "" : null
        field === "deliveryCountry" && this.deliveryCountry.trim() === "" ? this.errors.deliveryCountry = "Täytä" : null
        field === "deliveryCountry" && this.deliveryCountry.trim() !== "" ? this.errors.deliveryCountry = "" : null
        
        //field === "billingFormat" && this.billingFormat.trim() === "" ? this.errors.billingFormat = "Täytä" : null
        //field === "billingFormat" && this.billingFormat.trim() !== "" ? this.errors.billingFormat = "" : null
        if(field === "billingFormat") { 
          this.billingAddress = ""
          this.billingPostalCode = ""
          this.billingCity = ""
          this.billingCountry = ""
          this.eBillingAddress = ""; 
          this.eBillingOperator= "";
          this.differentBillingEmail = false; 
          this.differentBillingAddress = false;
          this.errors.billingFormat = ""
          this.errors.eBillingAddress = ""
          this.errors.eBillingOperator = ""
          this.errors.billingEmail = ""
        }
        //field === "eBillingAddress" && this.eBillingAddress.trim() === "" ? this.errors.eBillingAddress = "Täytä" : null
        //field === "eBillingAddress" && this.eBillingAddress.trim() !== "" ? this.errors.eBillingAddress = "" : null
        //field === "eBillingOperator" && this.eBillingOperator.trim() === "" ? this.errors.eBillingOperator = "Täytä" : null
        //field === "eBillingOperator" && this.eBillingOperator.trim() !== "" ? this.errors.eBillingOperator = "" : null
        field === "firstName" && this.firstName.trim() === "" ? this.errors.firstName = "Täytä" : null
        field === "firstName" && this.firstName.trim() !== "" ? this.errors.firstName = "" : null
        field === "lastName" && this.lastName.trim() === "" ? this.errors.lastName = "Täytä" : null
        field === "lastName" && this.lastName.trim() !== "" ? this.errors.lastName = "" : null
        field === "clientPhone" && this.clientPhone.trim() === "" ? this.errors.clientPhone = "Täytä" : null
        field === "clientPhone" && this.clientPhone.trim() !== "" ? this.errors.clientPhone = "" : null
        if(this.differentBillingEmail) {
          field === "billingEmail" && this.billingEmail.trim() === "" ? this.errors.billingEmail = "Täytä" : null
          field === "billingEmail" && this.billingEmail.trim() !== "" ? this.errors.billingEmail = "" : null
        }
        
        if(field === "clientEmail" && this.clientEmail.trim() === "") {
          this.errors.clientEmail = "Täytä"
        } 
        else if (field === "clientEmail" && !pattern.test(this.clientEmail)) this.errors.clientEmail = "Ei kelpaa"
        else this.errors.clientEmail = ""
        
      },
      removePromotionTemplateSelection () {
        this.selectedPromotionTemplateId = ''
        this.promotionEmailSubject = ""
        this.promotionMainHeadline = ""
        this.promotionMainSubHeader = ""
        this.promotionTemplateName = ""
        this.$store.dispatch('resetPromotionProducts', "")
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
        this.$refs.newPromotionProducts.addProductToPromotion()
      },
      removeExistingPromotionSelection () {
        this.selectedExistingPromotionId = ''
        this.promotionEmailSubject = ""
        this.promotionMainHeadline = ""
        this.promotionMainSubHeader = ""
        this.selectedCompanyId = ''
        this.selectedContactId = ''
        this.existingCompanySelected = false
        this.existingContactSelected = false
        this.companyFieldChanged()
        this.contactFieldChanged()
        this.$store.dispatch('resetPromotionProducts', "")
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
        this.$refs.newPromotionProducts.addProductToPromotion()
      },
      removeCompanySelection () {
        this.selectedCompanyId = ''
        this.selectedContactId = ''
        this.existingCompanySelected = false
        this.existingContactSelected = false
        this.companyFieldChanged()
        this.contactFieldChanged()
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
      },
      removeContactSelection () {
        this.selectedContactId = ''
        this.existingContactSelected = false
        this.contactFieldChanged()
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
      },
      removeCompanySelectionForList () {
        this.selectedCompanyIdForList = ''
        this.selectedContactIdList = ''
        var addExistingContacterrors = this.addExistingContacterrors
        Object.keys(this.addExistingContacterrors).forEach(errorKey => addExistingContacterrors[errorKey] = "")
      },
      removeContactSelectionForList () {
        this.selectedContactIdForList = ''
        this.addExistingContacterrors.contact = ''
      },
      promotionTemplateFieldChanged(){
        this.promotionEmailSubject = this.promotionTemplatesMap[this.selectedPromotionTemplateId].promotionEmailSubject
        this.promotionMainHeadline = this.promotionTemplatesMap[this.selectedPromotionTemplateId].promotionMainHeadline
        this.promotionMainSubHeader = this.promotionTemplatesMap[this.selectedPromotionTemplateId].promotionMainSubHeader
        this.promotionTemplateName = this.promotionTemplatesMap[this.selectedPromotionTemplateId].promotionTemplateName
        this.$store.dispatch('resetPromotionProducts', "")
        this.$refs.newPromotionProducts.addProductsToPromotion(this.promotionTemplatesMap[this.selectedPromotionTemplateId].products)
        this.generatePreview()
      },
      existingPromotionFieldChanged(){
        //console.log(this.selectedExistingPromotionId)
        this.selectedPromotionTemplateId = ""
        this.selectedCompanyId = this.promotionsMap[this.selectedExistingPromotionId].companyId
        this.selectedContactId = this.promotionsMap[this.selectedExistingPromotionId].contactId
        this.promotionEmailSubject = this.promotionsMap[this.selectedExistingPromotionId].promotionEmailSubject
        this.promotionMainHeadline = this.promotionsMap[this.selectedExistingPromotionId].promotionMainHeadline
        this.promotionMainSubHeader = this.promotionsMap[this.selectedExistingPromotionId].promotionMainSubHeader
        this.$store.dispatch('resetPromotionProducts', "")
        //this.orderComments = this.promotions[this.selectedExistingPromotionId].orderComments
        this.deliveryCharges = this.promotionsMap[this.selectedExistingPromotionId].deliveryCharges !== undefined ? this.promotionsMap[this.selectedExistingPromotionId].deliveryCharges : "24.90"
        this.companyFieldChanged()
        this.contactFieldChanged()
        var t = this
        db.collection("promotionProducts").where("promotionId", "==", this.selectedExistingPromotionId)
          .onSnapshot(function(querySnapshot) {
              var products = []
              querySnapshot.forEach(function(doc) {
                  products.push({...doc.data()})
              });
              t.$refs.newPromotionProducts.addProductsToPromotion(products)        
          })
      },
      companyFieldChanged() {
        this.selectedCompanyId === "" ? this.existingCompanySelected = false : this.existingCompanySelected = true
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].companyName !== "undefined" ? this.companyName = this.companies[this.selectedCompanyId].companyName : this.companyName = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].companyId !== "undefined" ? this.companyId = this.companies[this.selectedCompanyId].companyId : this.companyId = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].paymentTerm !== "undefined" ? this.paymentTerm = this.companies[this.selectedCompanyId].paymentTerm : this.paymentTerm = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].additionalCustomerInformation !== "undefined" ? this.additionalCustomerInformation = this.companies[this.selectedCompanyId].additionalCustomerInformation : this.additionalCustomerInformation = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].billingFormat !== "undefined" ? this.billingFormat = this.companies[this.selectedCompanyId].billingFormat : this.billingFormat = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].differentBillingEmail !== "undefined" ? this.differentBillingEmail = this.companies[this.selectedCompanyId].differentBillingEmail : this.differentBillingEmail = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].billingEmail !== "undefined" ? this.billingEmail = this.companies[this.selectedCompanyId].billingEmail : this.billingEmail = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].eBillingAddress !== "undefined" ? this.eBillingAddress = this.companies[this.selectedCompanyId].eBillingAddress : this.eBillingAddress = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].eBillingOperator !== "undefined" ? this.eBillingOperator = this.companies[this.selectedCompanyId].eBillingOperator : this.eBillingOperator = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].differentBillingAddress !== "undefined" ? this.differentBillingAddress = this.companies[this.selectedCompanyId].differentBillingAddress : this.differentBillingAddress = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].billingAddress !== "undefined" ? this.billingAddress = this.companies[this.selectedCompanyId].billingAddress : this.billingAddress = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].billingPostalCode !== "undefined" ? this.billingPostalCode = this.companies[this.selectedCompanyId].billingPostalCode : this.billingPostalCode = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].billingCity !== "undefined"  ? this.billingCity = this.companies[this.selectedCompanyId].billingCity : this.billingCity = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].billingCountry !== "undefined"  ? this.billingCountry = this.companies[this.selectedCompanyId].billingCountry : this.billingCountry = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].deliveryAddress !== "undefined" ? this.deliveryAddress = this.companies[this.selectedCompanyId].deliveryAddress : this.deliveryAddress = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].deliveryPostalCode !== "undefined" ? this.deliveryPostalCode = this.companies[this.selectedCompanyId].deliveryPostalCode : this.deliveryPostalCode = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].deliveryCity !== "undefined" ? this.deliveryCity = this.companies[this.selectedCompanyId].deliveryCity : this.deliveryCity = ""
        this.selectedCompanyId && typeof this.companies[this.selectedCompanyId].deliveryCountry !== "undefined" ? this.deliveryCountry = this.companies[this.selectedCompanyId].deliveryCountry : this.deliveryCountry = ""
      },
      contactFieldChanged() {
        this.selectedContactId === "" ? this.existingContactSelected = false : this.existingContactSelected = true
        this.selectedContactId && this.contacts[this.selectedContactId].firstName !== "undefined" && this.contacts[this.selectedContactId].firstName ? this.firstName = this.contacts[this.selectedContactId].firstName : this.firstName = ""
        this.selectedContactId && this.contacts[this.selectedContactId].lastName !== "undefined" && this.contacts[this.selectedContactId].lastName ? this.lastName = this.contacts[this.selectedContactId].lastName : this.lastName = ""
        this.selectedContactId && this.contacts[this.selectedContactId].phone !== "undefined" && this.contacts[this.selectedContactId].phone ? this.clientPhone = this.contacts[this.selectedContactId].phone : this.clientPhone = ""
        this.selectedContactId && this.contacts[this.selectedContactId].clientEmail !== "undefined" && this.contacts[this.selectedContactId].email ? this.clientEmail = this.contacts[this.selectedContactId].email : this.clientEmail = ""
        this.selectedContactId && this.contacts[this.selectedContactId].sendConfirmation !== "undefined" && this.contacts[this.selectedContactId].sendConfirmation ? this.sendConfirmation = this.contacts[this.selectedContactId].sendConfirmation : this.sendConfirmation = ""
        this.selectedContactId && this.contacts[this.selectedContactId].additionalCustomerInformation !== "undefined" ? this.additionalCustomerInformation = this.contacts[this.selectedContactId].additionalCustomerInformation : this.additionalCustomerInformation = ""
        this.fieldUpdated("firstName")
        this.fieldUpdated("lastName")
        this.fieldUpdated("clientPhone")
        this.fieldUpdated("clientEmail")
      },
      async updatePromotionTemplate(){
        var promotionProductsSummaryIds = ""
        var promotionProductsSummary = ""
        var promotionTemplateId = this.selectedPromotionTemplateId
        var productsToInsert = []
        for (var i = 0; i < this.products.length; i++) { 
          var product = this.products[i]
          if(product.productVariationId === null || product.productVariationId === "") continue
          //promotionProductsSummary += product.productName + " x " +product.quantity + ";"
          //promotionProductsSummaryIds += product.productVariationId + " " + this.productVariations[product.productVariationId].sku + ";"
          productsToInsert.push({
            customerProductDescription:product.customerProductDescription,
            customerProductName:product.customerProductName,
            productNoticeText:product.productNoticeText,
            productId:product.productId,
            productVariationId:product.productVariationId,
            selectedFileId:product.selectedFileId !== undefined ? product.selectedFileId : '',
            selectedFileUrl:product.selectedFileUrl !== undefined ? product.selectedFileUrl : "",
            selected2FileId:product.selected2FileId !== undefined ? product.selected2FileId : "",
            selected2FileUrl:product.selected2FileUrl !== undefined ? product.selected2FileUrl : "",
            selected3FileId:product.selected3FileId !== undefined ? product.selected3FileId : "",
            selected3FileUrl:product.selected3FileUrl !== undefined ? product.selected3FileUrl : "",
            selected4FileId:product.selected4FileId !== undefined ? product.selected4FileId : "",
            selected4FileUrl:product.selected4FileUrl !== undefined ? product.selected4FileUrl : "",
            selected5FileId:product.selected5FileId !== undefined ? product.selected5FileId : "",
            selected5FileUrl:product.selected5FileUrl !== undefined ? product.selected5FileUrl : "",
            imageSize:product.imageSize,
            image2Size:product.image2Size,
            image3Size:product.image3Size,
            image4Size:product.image4Size,
            image5Size:product.image5Size,
            offers:product.offers,
            order:i
          })
        }
        if (this.selectedPromotionTemplateId !== ""){
          db.collection('promotionTemplates').doc(this.selectedPromotionTemplateId).set({
            updated_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_by:this.user.uid,
            promotionEmailSubject:this.promotionEmailSubject,
            promotionMainHeadline:this.promotionMainHeadline,
            promotionMainSubHeader:this.promotionMainSubHeader,
            promotionValidDate:this.promotionValidDate,
            promotionTemplateName:this.promotionTemplateName,
            products:productsToInsert,
            promotionProductsSummaryIds,
            promotionProductsSummary
          }, { merge: true })
        }
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Muutokset tallenettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      async createPromotionTemplate(){
        var promotionProductsSummaryIds = ""
        var promotionProductsSummary = ""
        var productsToInsert = []
        for (var i = 0; i < this.products.length; i++) { 
          var product = this.products[i]
          if(product.productVariationId === null || product.productVariationId === "") continue
          promotionProductsSummary += product.productName + " x " +product.quantity + ";"
          //console.log(this.productVariations[product.productVariationId])
          var pv = this.productVariations[product.productVariationId]

          promotionProductsSummaryIds += this.products[pv.productId] && this.products[pv.productId].avecorSku ? this.products[pv.productId].avecorSku + ";" : ''
          productsToInsert.push({
            customerProductDescription:product.customerProductDescription,
            customerProductName:product.customerProductName,
            productNoticeText:product.productNoticeText,
            productId:product.productId,
            productVariationId:product.productVariationId,
            selectedFileId:product.selectedFileId,
            selectedFileUrl:product.selectedFileUrl,
            selected2FileId:product.selected2FileId !== undefined ? product.selected2FileId : "",
            selected2FileUrl:product.selected2FileUrl !== undefined ? product.selected2FileUrl : "",
            selected3FileId:product.selected3FileId !== undefined ? product.selected3FileId : "",
            selected3FileUrl:product.selected3FileUrl !== undefined ? product.selected3FileUrl : "",
            imageSize:product.imageSize,
            image2Size:product.image2Size !== undefined ? product.image2Size : "L",
            image3Size:product.image3Size !== undefined ? product.image3Size : "L",
            offers:product.offers,
            order:i
          })
        }
        const promotionTemplateRef = db.collection('promotionTemplates').doc()
        const promotionTemplateId = promotionTemplateRef.id
        promotionTemplateRef.set({
          id:promotionTemplateId,
          created_at:firebase.firestore.FieldValue.serverTimestamp(),
          created_by:this.user.uid,
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          promotionEmailSubject:this.promotionEmailSubject,
          promotionMainHeadline:this.promotionMainHeadline,
          promotionMainSubHeader:this.promotionMainSubHeader,
          deliveryCharges:this.deliveryCharges !== undefined ? this.deliveryCharges : "24,90",
          promotionTemplateName:this.newPromotionTemplateName,
          products:productsToInsert,
          promotionProductsSummaryIds,
          promotionProductsSummary
        })
        //this.selectedPromotionTemplateId = promotionTemplateId
        
        //this.promotionTemplateFieldChanged()
        this.newPromotionTemplateName = ""
        //this.resetPromotion()
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Uusi tarjouspohja luotu. Valitse pohja pudotusvalikosta.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        
        
      },
      async deletePromotionTemplate(promotionTemplateId){
          await db.collection('promotionTemplates').doc(promotionTemplateId).delete()
      },
      async deletePromotion(promotionId){
          //console.log("Deleting " + promotionId)
          this.selectedPromotionIdForResults = ""
          var promotionProductsQuery = db.collection('promotionProducts').where('promotionId','==',promotionId);
          promotionProductsQuery.get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              doc.ref.delete();
            });
          });
          var contactActivitiesQuery = db.collection('contactActivities').where('promotionId','==',promotionId);
          contactActivitiesQuery.get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              doc.ref.delete();
            });
          });
          await db.collection('promotions').doc(promotionId).delete()
      },
      async validateAndCreatePromotion(){
        var errors = []
        var errorsVisible = this.errors
        var productsErrors = this.productsErrors
        Object.keys(this.errors).forEach(errorKey => errorsVisible[errorKey] = "")
        this.productsErrors.forEach((product,i) => {
          Object.keys(product).forEach(errorKey => productErrors[i][errorKey] = "")
        })
        if(this.selectedSendType === "sendToOne"){
          if (this.companyName === undefined || this.companyName.trim() == "") { this.errors.companyName = "Täytä"; errors.push("Yrityksen nimi") }
          if (this.deliveryAddress === undefined || this.deliveryAddress.trim() == "") { this.errors.deliveryAddress = "Täytä"; errors.push("Toimitusosoite") }
          if (this.deliveryPostalCode === undefined || this.deliveryPostalCode.trim() == "") { this.errors.deliveryPostalCode = "Täytä"; errors.push("Postikoodi") }
          if (this.deliveryCity === undefined || this.deliveryCity.trim() == "") { this.errors.deliveryCity = "Täytä"; errors.push("Toimipaikka")}
          if (this.deliveryCountry === undefined || this.deliveryCountry.trim() == "") { this.errors.deliveryCountry = "Täytä"; errors.push("Maa") }
          
          //if (this.billingFormat.trim() == "") { this.errors.billingFormat = "Täytä"; errors.push("Laskutusformaatti") }
          //if (this.billingFormat.trim() == "eInvoice" && this.eBillingOperator == "") { this.errors.eBillingOperator = "Täytä"; errors.push("Sähkölaskutuksen operaattori") }
          //if (this.billingFormat.trim() == "eInvoice" && this.eBillingAddress == "") { this.errors.eBillingAddress = "Täytä"; errors.push("Verkkolaskutusosoite") }
          if (this.firstName === undefined || this.firstName.trim() == "") {this.errors.firstName = "Täytä"; errors.push("Tilaajan etunimi") }
          if (this.lastName === undefined || this.lastName.trim() == "") { this.errors.lastName = "Täytä"; errors.push("Tilaajan sukunimi") }
          if (this.clientPhone === undefined || this.clientPhone.trim() == "") { this.errors.clientPhone = "Täytä"; errors.push("Tilaajan puhelin")}
          if (this.clientEmail === undefined || this.clientEmail.trim() == "") { this.errors.clientEmail = "Täytä"; errors.push("Tilaajan sähköposti") }
          if (this.differentBillingEmail && this.billingEmail.trim() === "") { this.errors.billingEmail = "Täytä"; errors.push("Laskutuksen sähköposti")}
        }
        var productsErrors = this.productsErrors
        this.products.forEach((product,i) => {
          //if (product.productId.trim() === "") {productsErrors[i].productId = "Täytä"; errors.push("product " + i + " error" )}
          if (product.productVariationId.trim() === "") {productsErrors[i].productVariationId = "Täytä"; errors.push("Tuote valittava")}
        })
        if(this.selectedSendType === "sendToList"){
          if(this.selectedListToSendTo === '') { this.errors.selectedList = "Valitse lista"; errors.push("Valitse lista, jolle haluat lähettää tarjouksen.")}
        }
        //console.log(errors)
        if(errors.length > 0) {
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:"Täytä puuttuvat kentät: " + errors.join(', '), snackColor:'error',right:true,top:true})
        }
        else {
          if(this.selectedSendType === "sendToOne"){
            var obj = await this.createCompanyAndContact()
            
            this.createPromotion({...obj,sendToStaffEmail:true})  
          }
          else if(this.selectedSendType === "sendToList"){
            if(this.selectedListToSendTo !== undefined && this.selectedListToSendTo !== ''){
              var length = this.lists[this.selectedListToSendTo].contacts.length
              this.bulkSendingActive = true,
              this.bulkSendPercentage = 0
              this.bulkSendNumber = 0
              this.lists[this.selectedListToSendTo].contacts.forEach(async (contact,index) => {
                if(index == 0){
                  await this.createPromotion({...contact,sendToStaffEmail:true})
                  this.bulkSendPercentage = (index+1/length)*100
                  this.bulkSendNumber = index+1  
                }
                else{
                  await this.createPromotion({...contact,sendToStaffEmail:false})  
                  this.bulkSendPercentage = (index+1/length)*100
                  this.bulkSendNumber = index+1
                }
                this.bulkSendPercentage = (index+1/length)*100
                if(index+1 == length){
                  this.bulkSendingActive = false,
                  this.bulkSendPercentage = 0
                  this.bulkSendNumber = 0
                }
              })
            }
          }
        }
      },
      async createCompanyAndContact(){
        var companyDBId = ""
        var contactDBId = ""
        var companyData = {
          companyName:this.companyName,
          companyId:this.companyId,
          paymentTerm:this.paymentTerm,
          deliveryAddress:this.deliveryAddress,
          deliveryPostalCode:this.deliveryPostalCode,
          deliveryCity:this.deliveryCity,
          deliveryCountry:this.deliveryCountry,
          billingFormat:this.billingFormat,
          billingEmail: this.billingEmail ? this.billingEmail : '',
          eBillingAddress: this.eBillingAddress,
          eBillingOperator: this.eBillingOperator,
          differentBillingEmail: this.differentBillingEmail ? this.differentBillingEmail : false,
          differentBillingAddress: this.differentBillingAddress ? this.differentBillingAddress : false,
          billingAddress:this.billingAddress,
          billingPostalCode:this.billingPostalCode,
          billingCity:this.billingCity,
          billingCountry:this.billingCountry,
          salesperson:this.user.uid,
        }
        if (this.selectedCompanyId === "") {
            companyDBId = await this.$store.dispatch('company/set', companyData)
            //this.$store.dispatch('company/batchSync')
        }
        else {
            companyDBId = this.selectedCompanyId
            this.$store.dispatch('company/set', {id:companyDBId, ...companyData})
            //this.$store.dispatch('company/batchSync')
        }
        var contactData = {
          companyId:companyDBId,
          firstName:this.firstName,
          lastName:this.lastName,
          phone:this.clientPhone ? this.clientPhone : '',
          email:this.clientEmail ? this.clientEmail : '',
          clientPrintDetailsEmail: this.clientPrintDetailsEmail ? this.clientPrintDetailsEmail: '',
          sendConfirmation: this.sendConfirmation,
          comments:this.additionalCustomerInformation ? this.additionalCustomerInformation : '',
        }
        if (this.selectedContactId === "") { 
          contactDBId = await this.$store.dispatch('contact/set', contactData)
          //this.$store.dispatch('contact/batchSync')
        }
        else {
          contactDBId = this.selectedContactId
          await this.$store.dispatch('contact/set', {id:contactDBId, ...contactData})
          //this.$store.dispatch('contact/batchSync')
        }
        var obj = {contactId:contactDBId,companyId:companyDBId}
        return obj
      },
      async createPromotion(obj){
        const promotionRef = db.collection('promotions').doc()
        const promotionId = promotionRef.id
        await promotionRef.set({
          id:promotionId,
          created_at:firebase.firestore.FieldValue.serverTimestamp(),
          created_by:this.user.uid,
          updated_at:firebase.firestore.FieldValue.serverTimestamp(),
          updated_by:this.user.uid,
          companyId:obj.companyId,
          contactId:obj.contactId,
          promotionTemplateId:this.selectedPromotionTemplateId,
          promotionEmailSubject:this.promotionEmailSubject,
          promotionMainHeadline:this.promotionMainHeadline,
          promotionMainSubHeader:this.promotionMainSubHeader,
          promotionValidDate:this.promotionValidDate,
          emailSends:0,
          emailOpens:0,
          emailClicks:0,
        })
        //promotionId = promotionRef.id

        var promotionSummaryIds = ""
        var promotionSummary = ""
        for (var i = 0; i < this.products.length; i++) { 
          var product = this.products[i]
          if(product.productVariationId === null || product.productVariationId === "") continue
          promotionSummary += product.productName + " x " +product.quantity + ";"
          if (product.productId.trim() !== "") {
            //promotionSummaryIds += product.productVariationId + " " + this.productVariations[product.productVariationId].sku + ";"
            const promotionProductRef = db.collection('promotionProducts').doc();
            const promotionProductId = promotionProductRef.id;
            await promotionProductRef.set({
              id:promotionProductId,
              created_at:firebase.firestore.FieldValue.serverTimestamp(),
              created_by:this.user.uid,
              updated_at:firebase.firestore.FieldValue.serverTimestamp(),
              updated_by:this.user.uid,
              productId:product.productId,
              productVariationId:product.productVariationId,
              customerProductName: product.customerProductName,
              customerProductDescription: product.customerProductDescription,
              productNoticeText:product.productNoticeText,
              promotionId,
              selectedFileId:product.selectedFileId,
              selectedFileUrl:product.selectedFileUrl,
              selected2FileId:product.selected2FileId,
              selected2FileUrl:product.selected2FileUrl,
              selected3FileId:product.selected3FileId,
              selected3FileUrl:product.selected3FileUrl,
              imageSize:product.imageSize,
              image2Size:product.image2Size,
              image3Size:product.image3Size,
              offers:product.offers,
            })
          }
        }
        db.collection('promotions').doc(promotionId).set({
            promotionSummaryIds,
            promotionSummary,
        }, { merge: true })
        
        await this.sendPromotionViaServer({promotionId,contactId:obj.contactId,companyId:obj.companyId,isTest:false,sendToStaffEmail:obj.sendToStaffEmail})
      },
      sendTestPromotion(){
        this.sendPromotionViaServer({isTest:true,sendToStaffEmail:true})
      },
      getHTML(){
        var t = this
        var html = avecorLibrary.generatePromotionEmailHTML(t.newPromotionDetails, t.products, t.staff[t.user.uid], "")
        console.log(html)
      },
      sendPromotionViaServer(obj){
        var t = this
        //var email = t.clientEmail
        var toEmail = obj.isTest ? t.user.email : t.contacts[obj.contactId].email
        var promotionId = obj.promotionId ? obj.promotionId : ""
        var contactId = obj.contactId ? obj.contactId : ""
        var companyId = obj.companyId ? obj.companyId : ""
        //https://us-central1-logogear-erp.cloudfunctions.net/sendMessage
        var url = this.settings.dev ? 'http://api-test2.avecor.fi:5000/logogear-erp/us-central1/sendMessage' : 'https://us-central1-logogear-erp.cloudfunctions.net/sendMessage'
        firebase.auth().currentUser.getIdToken().then(function(token){
          var html = avecorLibrary.generatePromotionEmailHTML(t.newPromotionDetails, t.products, t.staff[t.user.uid], "")
          axios.defaults.headers.common['Authorization'] = "Bearer " +token;
          axios.post(
              url,
              {
                  toEmail,
                  toName: t.clientName,
                  fromEmail:t.user.email,
                  fromName: t.staff[t.user.uid].firstName + " " + t.staff[t.user.uid].lastName,
                  html,
                  isTest:obj.isTest,
                  sendToStaffEmail:obj.sendToStaffEmail,
                  subject:t.promotionEmailSubject,
                  promotionId,
                  contactId,
                  companyId,
              }
          )
          .then(function(response) {
              console.log(response)
              if(obj.isTest){
                t.messageSent({error:false, message:'Testi tarjous lähetetty.'})
              }
              else{
                t.messageSent({error:false, message:'Tarjous lähetetty ja tallennettu. Voit seurata sähköpostin avauksia tulokset välilehdeltä.'})
              }
              
          })
          .catch(function(error) {
              t.messageSent({error:true, message:error})
              //console.log(error);
          });
        })
      },
      messageSent(message) {
        if(message.error) {
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:message.message, snackButtonText: "OK", snackColor:'error',right:true,top:true})
        }
        else {
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:5000, snackText:message.message, snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
      }
    }
  }
</script>

<style>
  #promotionEmailPreview, #promotionPDFPreview{
    border:1px solid #ccc;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/Promotions.vue